(() => {
// -----------------------------------------
// BOILERPLATE
// -----------------------------------------
// GSAP setup
gsap.config({
    nullTargetWarn: false
});
gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase, ScrambleTextPlugin);
/* ---------------------------
   1. Utility & Setup
--------------------------- */ // Custom Ease
CustomEase.create("punch", "M0,0 C0.19,1 0.22,1 1,1");
CustomEase.create("energy", "M0,0 C0.32,0.72 0,1 1,1");
CustomEase.create("jump", "M0,0 C0.35,1.5 0.6,1 1,1");
// Set --vh and --vw custom properties
const $7fe0fc961c0a5700$var$mobileMQ = window.matchMedia('(max-width: 768px)');
function $7fe0fc961c0a5700$var$setRealVH() {
    const root = document.documentElement.style;
    root.setProperty('--vw', `${window.innerWidth * 0.01}px`);
    root.setProperty('--vwinner', `${(window.innerWidth - 64) * 0.01}px`);
    if ($7fe0fc961c0a5700$var$mobileMQ.matches) root.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    else root.removeProperty('--vh'); // desktop falls back to 1vh in CSS
}
// rotation / real width changes only (your existing helper ignores URL-bar resizes)
window.addEventListener('resize', $7fe0fc961c0a5700$var$debounceOnWidthChange($7fe0fc961c0a5700$var$setRealVH, 200));
// OSMO START
history.scrollRestoration = "manual";
let $7fe0fc961c0a5700$var$lenis = null;
let $7fe0fc961c0a5700$var$nextPage = document;
let $7fe0fc961c0a5700$var$onceFunctionsInitialized = false;
//let unicornSceneInitialized = false;
const $7fe0fc961c0a5700$var$hasLenis = typeof window.Lenis !== "undefined";
const $7fe0fc961c0a5700$var$hasScrollTrigger = typeof window.ScrollTrigger !== "undefined";
const $7fe0fc961c0a5700$var$rmMQ = window.matchMedia("(prefers-reduced-motion: reduce)");
let $7fe0fc961c0a5700$var$reducedMotion = $7fe0fc961c0a5700$var$rmMQ.matches;
$7fe0fc961c0a5700$var$rmMQ.addEventListener?.("change", (e)=>$7fe0fc961c0a5700$var$reducedMotion = e.matches);
$7fe0fc961c0a5700$var$rmMQ.addListener?.((e)=>$7fe0fc961c0a5700$var$reducedMotion = e.matches);
const $7fe0fc961c0a5700$var$has = (s)=>!!$7fe0fc961c0a5700$var$nextPage.querySelector(s);
let $7fe0fc961c0a5700$var$staggerDefault = 0.05;
let $7fe0fc961c0a5700$var$durationDefault = 0.6;
CustomEase.create("osmo", "0.625, 0.05, 0, 1");
gsap.defaults({
    ease: "osmo",
    duration: $7fe0fc961c0a5700$var$durationDefault
});
// -----------------------------------------
// FUNCTION REGISTRY
// -----------------------------------------
function $7fe0fc961c0a5700$var$initOnceFunctions() {
    $7fe0fc961c0a5700$var$initLenis();
    if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.stop();
    if ($7fe0fc961c0a5700$var$onceFunctionsInitialized) return;
    $7fe0fc961c0a5700$var$onceFunctionsInitialized = true;
    $7fe0fc961c0a5700$var$initAriaCleanup();
    $7fe0fc961c0a5700$var$initHeaderScroll();
    if ($7fe0fc961c0a5700$var$has('[data-speed]')) $7fe0fc961c0a5700$var$initParallax();
    $7fe0fc961c0a5700$var$initEffect086();
}
function $7fe0fc961c0a5700$var$initBeforeEnterFunctions(next) {
    $7fe0fc961c0a5700$var$nextPage = next || document;
    $7fe0fc961c0a5700$var$updateActiveMenu();
    // Runs before the enter animation
    // if (has('[data-something]')) initSomething();
    if ($7fe0fc961c0a5700$var$has('.d-ct-particles')) $7fe0fc961c0a5700$var$initParticleTriangle(next);
    if ($7fe0fc961c0a5700$var$has('.mwg_effect106')) $7fe0fc961c0a5700$var$initEffect106(next);
    if ($7fe0fc961c0a5700$var$has('.d-ct-particles-follow')) $7fe0fc961c0a5700$var$initParticleFollow(next);
}
function $7fe0fc961c0a5700$var$initAfterEnterFunctions(next) {
    $7fe0fc961c0a5700$var$nextPage = next || document;
    const run = (name, fn)=>{
        try {
            fn();
        } catch (e) {
            console.error(`[init:${name}]`, e);
        }
    };
    run('reInitScripts', ()=>$7fe0fc961c0a5700$var$reInitScripts(next));
    run('lazy', ()=>$7fe0fc961c0a5700$var$initLazyImageListeners(next));
    if ($7fe0fc961c0a5700$var$has('.fade-image')) run('fadeInImages', ()=>$7fe0fc961c0a5700$var$fadeInImages(next));
    if ($7fe0fc961c0a5700$var$has('.d-reveal')) run('dReveal', ()=>$7fe0fc961c0a5700$var$dRevealTextLine(next));
    if ($7fe0fc961c0a5700$var$has('.d-reveal-f')) run('dFade', ()=>$7fe0fc961c0a5700$var$dFadeTextLine(next));
    if ($7fe0fc961c0a5700$var$has('.mwg_effect036')) run('036', ()=>$7fe0fc961c0a5700$var$initEffect036(next));
    if ($7fe0fc961c0a5700$var$has('[data-gradient-wave-text]')) run('wave', ()=>$7fe0fc961c0a5700$var$initGradientWaveText(next));
    if ($7fe0fc961c0a5700$var$has('.mwg_effect056')) run('056', ()=>$7fe0fc961c0a5700$var$initEffect056(next));
    if ($7fe0fc961c0a5700$var$has('.mwg_effect082')) run('082', ()=>$7fe0fc961c0a5700$var$initEffect082(next));
    if ($7fe0fc961c0a5700$var$has('video[autoplay]')) run('video', ()=>$7fe0fc961c0a5700$var$initAutoplayVideos(next));
    if ($7fe0fc961c0a5700$var$has('[data-directional-hover]')) {
        run('dirHover', ()=>$7fe0fc961c0a5700$var$initDirectionalListHover(next));
        run('dirReveal', ()=>$7fe0fc961c0a5700$var$initDirectionalHoverReveal(next));
    }
    if ($7fe0fc961c0a5700$var$has('.mwg_effect029')) run('029', ()=>$7fe0fc961c0a5700$var$initEffect029(next));
    if ($7fe0fc961c0a5700$var$has('[data-speed]')) run('parallax', ()=>$7fe0fc961c0a5700$var$initParallax(next));
    if ($7fe0fc961c0a5700$var$has('.corner3')) run('corner3', ()=>$7fe0fc961c0a5700$var$initCorner3Reveal(next));
    if ($7fe0fc961c0a5700$var$has('.d-ct-pin-bottom')) run('pinBottom', ()=>$7fe0fc961c0a5700$var$initPinBottom(next));
    if ($7fe0fc961c0a5700$var$has('.d-ct-rotor')) run('rotor', ()=>$7fe0fc961c0a5700$var$initRotorRotation(next));
    if ($7fe0fc961c0a5700$var$has('.d-ct-border-box-h')) run('borderBoxH', ()=>$7fe0fc961c0a5700$var$initBorderBoxHReveal(next));
    if ($7fe0fc961c0a5700$var$has('.d-project-case')) run('projectCase', ()=>$7fe0fc961c0a5700$var$initProjectCase(next));
    if ($7fe0fc961c0a5700$var$has('.d-project-block')) run('projectBlock', ()=>$7fe0fc961c0a5700$var$initProjectBlock(next));
    if ($7fe0fc961c0a5700$var$has('.d-d26-wwd-pin')) run('wwdPin', ()=>$7fe0fc961c0a5700$var$initWwdPin(next));
    if ($7fe0fc961c0a5700$var$has('[data-scramble="scroll"]')) run('scrollScramble', ()=>$7fe0fc961c0a5700$var$initScrambleOnScroll(next));
    if ($7fe0fc961c0a5700$var$has('[data-marquee-scroll-direction-target]')) run('marquee', ()=>$7fe0fc961c0a5700$var$initMarqueeScrollDirection(next));
    if ($7fe0fc961c0a5700$var$has('.d-d26-imgfly')) run('imgfly', ()=>$7fe0fc961c0a5700$var$initImgFly(next));
    if ($7fe0fc961c0a5700$var$has('[data-pixelate-render]')) run('pixelate', ()=>$7fe0fc961c0a5700$var$initPixelateImageRender(next));
    if ($7fe0fc961c0a5700$var$has('.d-project-screens')) run('projectWarp', ()=>$7fe0fc961c0a5700$var$initProjectImgWarp(next));
    if ($7fe0fc961c0a5700$var$has('.mwg_effect036')) run('036glass', ()=>$7fe0fc961c0a5700$var$initEffect036Glass(next));
    if ($7fe0fc961c0a5700$var$hasLenis) $7fe0fc961c0a5700$var$lenis.resize();
    if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.refresh();
}
// -----------------------------------------
// PAGE TRANSITIONS
// -----------------------------------------
let $7fe0fc961c0a5700$var$onceTl = null;
function $7fe0fc961c0a5700$var$runPageOnceAnimation(next) {
    $7fe0fc961c0a5700$var$onceTl = gsap.timeline({
        delay: 0,
        onComplete: ()=>{}
    });
    const tl = $7fe0fc961c0a5700$var$onceTl;
    $7fe0fc961c0a5700$var$heroPinDeferred = true;
    const bgBO = document.querySelector(".d-barba-once-wrapper");
    const bgBO1 = document.querySelector(".d-barba-once-1");
    const bgBO2 = document.querySelector(".d-barba-once-2");
    const bgBO3 = document.querySelector(".d-barba-once-3");
    const bgBO4 = document.querySelector(".d-barba-once-4");
    const bgBO5 = document.querySelector(".d-barba-once-5");
    const bgStart = "+=0.3";
    tl.set(bgBO, {
        clipPath: "inset(0% 0% 0% 0%)"
    });
    tl.set(bgBO1, {
        scale: 0,
        opacity: 1
    });
    tl.addLabel("bgReveal", bgStart);
    tl.to(bgBO1, {
        scale: 1,
        duration: 0.6,
        transformOrigin: "50% 90%",
        ease: "back.out(1.7)"
    }, "bgReveal");
    tl.set(bgBO2, {
        opacity: 1,
        xPercent: 0
    }, "bgReveal+=0.3");
    tl.set(bgBO3, {
        opacity: 1,
        xPercent: 0
    }, "bgReveal+=0.5");
    tl.set(bgBO4, {
        opacity: 1,
        xPercent: 0
    }, "bgReveal+=0.3");
    tl.set(bgBO5, {
        opacity: 1,
        xPercent: 0
    }, "bgReveal+=0.5");
    tl.to(bgBO2, {
        xPercent: -100,
        duration: 0.5,
        ease: "back.out(1.4)"
    }, "bgReveal+=0.3");
    tl.to(bgBO4, {
        xPercent: 150,
        duration: 0.5,
        ease: "back.out(1.4)"
    }, "bgReveal+=0.3");
    tl.to(bgBO3, {
        xPercent: -100,
        duration: 0.5,
        ease: "back.out(1.1)"
    }, "bgReveal+=0.5");
    tl.to(bgBO5, {
        xPercent: 100,
        duration: 0.5,
        ease: "back.out(1.1)"
    }, "bgReveal+=0.5");
    tl.to(bgBO2, {
        xPercent: 0,
        duration: 0.5,
        ease: "back.in(1.4)"
    }, "bgReveal+=1.4");
    tl.to(bgBO4, {
        xPercent: 0,
        duration: 0.5,
        ease: "back.in(1.4)"
    }, "bgReveal+=1.4");
    tl.to(bgBO3, {
        xPercent: 200,
        duration: 0.4,
        ease: "power2.in"
    }, "bgReveal+=1.7");
    tl.to(bgBO5, {
        xPercent: -200,
        duration: 0.4,
        ease: "power2.in"
    }, "bgReveal+=1.7");
    tl.to(bgBO, {
        clipPath: "inset(0% 0% 100% 0%)",
        duration: 0.7,
        ease: "energy"
    }, "bgReveal+=2");
    tl.set(bgBO, {
        autoAlpha: 0
    }, "bgReveal+=2.8");
    tl.call(()=>{
        $7fe0fc961c0a5700$var$resetPage(next);
        $7fe0fc961c0a5700$var$heroPinDeferred = false;
        if ($7fe0fc961c0a5700$var$hasLenis) $7fe0fc961c0a5700$var$lenis.resize();
        if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.refresh();
    });
    return tl;
}
function $7fe0fc961c0a5700$var$runPageLeaveAnimation(current, next) {
    const bgBO = document.querySelector(".d-barba-once-wrapper");
    const bgBO1 = document.querySelector(".d-barba-once-1");
    const bgBO2 = document.querySelector(".d-barba-once-2");
    const bgBO3 = document.querySelector(".d-barba-once-3");
    const bgBO4 = document.querySelector(".d-barba-once-4");
    const bgBO5 = document.querySelector(".d-barba-once-5");
    const tl = gsap.timeline({});
    if ($7fe0fc961c0a5700$var$reducedMotion) {
        tl.set(current, {
            autoAlpha: 0
        });
        return Promise.resolve();
    }
    tl.set(next, {
        autoAlpha: 0
    }, 0);
    tl.set(bgBO, {
        autoAlpha: 1
    }, 0);
    tl.set(bgBO, {
        clipPath: "inset(100% 0% 0% 0%)"
    }, 0);
    tl.set(bgBO1, {
        xPercent: 0,
        yPercent: 30
    }, 0);
    tl.set(bgBO2, {
        xPercent: -100,
        yPercent: 30
    }, 0);
    tl.set(bgBO3, {
        xPercent: -100,
        yPercent: 30
    }, 0);
    tl.set(bgBO4, {
        xPercent: 150,
        yPercent: 30
    }, 0);
    tl.set(bgBO5, {
        xPercent: 100,
        yPercent: 30
    }, 0);
    tl.to(bgBO, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.7,
        ease: "energy"
    }, 0.1);
    tl.to(bgBO1, {
        yPercent: 0,
        duration: 0.6,
        ease: "energy"
    }, 0.2);
    tl.to(bgBO2, {
        yPercent: 0,
        duration: 0.6,
        ease: "energy"
    }, 0.2);
    tl.to(bgBO3, {
        yPercent: 0,
        duration: 0.6,
        ease: "energy"
    }, 0.2);
    tl.to(bgBO4, {
        yPercent: 0,
        duration: 0.6,
        ease: "energy"
    }, 0.2);
    tl.to(bgBO5, {
        yPercent: 0,
        duration: 0.6,
        ease: "energy"
    }, 0.2);
    // Kill ScrollTriggers mid-animation while columns are rising,
    // so the main thread is free by the time leave resolves
    tl.call(()=>{
        if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.getAll().forEach((t)=>t.kill());
    }, null, 0.8);
    // Resolve as soon as the column fully covers the screen
    return new Promise((resolve)=>{
        tl.call(resolve, null, 0.8);
    });
}
function $7fe0fc961c0a5700$var$runPageEnterAnimation(next) {
    const tl = gsap.timeline();
    if ($7fe0fc961c0a5700$var$reducedMotion) {
        tl.set(next.container, {
            autoAlpha: 1
        });
        tl.add("pageReady");
        tl.call($7fe0fc961c0a5700$var$resetPage, [
            next.container
        ], "pageReady");
        return new Promise((resolve)=>tl.call(resolve, null, "pageReady"));
    }
    tl.set(next.container, {
        autoAlpha: 1
    }, 0);
    const root = next.container;
    const bgBO = document.querySelector(".d-barba-once-wrapper");
    const bgBO1 = document.querySelector(".d-barba-once-1");
    const bgBO2 = document.querySelector(".d-barba-once-2");
    const bgBO3 = document.querySelector(".d-barba-once-3");
    const bgBO4 = document.querySelector(".d-barba-once-4");
    const bgBO5 = document.querySelector(".d-barba-once-5");
    const header1 = document.querySelectorAll('.d-header-container');
    const bgStart = "+=0";
    tl.set(bgBO, {
        clipPath: "inset(0% 0% 0% 0%)"
    });
    tl.set(header1, {
        autoAlpha: 1
    });
    tl.addLabel("bgReveal", bgStart);
    tl.to(bgBO2, {
        xPercent: 0,
        duration: 0.5,
        ease: "back.in(1.4)"
    }, "bgReveal+=0");
    tl.to(bgBO4, {
        xPercent: 0,
        duration: 0.5,
        ease: "back.in(1.4)"
    }, "bgReveal+=0");
    tl.to(bgBO3, {
        xPercent: 200,
        duration: 0.4,
        ease: "power2.in"
    }, "bgReveal+=0.3");
    tl.to(bgBO5, {
        xPercent: -200,
        duration: 0.4,
        ease: "power2.in"
    }, "bgReveal+=0.3");
    tl.to(bgBO, {
        clipPath: "inset(0% 0% 100% 0%)",
        duration: 0.7,
        ease: "energy"
    }, "bgReveal+=0.6");
    tl.set(bgBO, {
        autoAlpha: 0
    }, "bgReveal+=1.4");
    tl.add("pageReady");
    tl.call($7fe0fc961c0a5700$var$resetPage, [
        next.container
    ], "pageReady");
    return new Promise((resolve)=>{
        tl.call(resolve, null, "pageReady");
    });
}
// -----------------------------------------
// BARBA HOOKS + INIT
// -----------------------------------------
barba.hooks.beforeEnter((data)=>{
    $7fe0fc961c0a5700$var$setRealVH();
    gsap.set(data.next.container, {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0
    });
    if ($7fe0fc961c0a5700$var$lenis && typeof $7fe0fc961c0a5700$var$lenis.stop === "function") $7fe0fc961c0a5700$var$lenis.stop();
    $7fe0fc961c0a5700$var$initBeforeEnterFunctions(data.next.container);
});
barba.hooks.afterLeave((data)=>{
    // ScrollTriggers are already killed inside runPageLeaveAnimation at 0.5s
    // so this hook stays lightweight and doesn't cause a gap before enter
    $7fe0fc961c0a5700$var$cleanupdRevealTextLine(data.current.container);
    $7fe0fc961c0a5700$var$cleanupdFadeTextLine(data.current.container);
    $7fe0fc961c0a5700$var$cleanupHexRevealR(data.current.container);
    $7fe0fc961c0a5700$var$cleanupHexRevealL(data.current.container);
    $7fe0fc961c0a5700$var$cleanupGradientWaveText(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect056(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect082(data.current.container);
    $7fe0fc961c0a5700$var$destroyInkMask(data.current.container);
    $7fe0fc961c0a5700$var$cleanupDirectionalHoverReveal(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect029(data.current.container);
    $7fe0fc961c0a5700$var$cleanupParallax();
    $7fe0fc961c0a5700$var$cleanupCorner3Reveal(data.current.container);
    $7fe0fc961c0a5700$var$cleanupPinBottom(data.current.container);
    $7fe0fc961c0a5700$var$cleanupRotorRotation(data.current.container);
    $7fe0fc961c0a5700$var$cleanupBorderBoxHReveal(data.current.container);
    $7fe0fc961c0a5700$var$cleanupParticleTriangle(data.current.container);
    $7fe0fc961c0a5700$var$cleanupParticleFollow(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect106(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect036(data.current.container);
    $7fe0fc961c0a5700$var$cleanupProjectCase(data.current.container);
    $7fe0fc961c0a5700$var$cleanupProjectBlock(data.current.container);
    $7fe0fc961c0a5700$var$cleanupWwdPin(data.current.container);
    $7fe0fc961c0a5700$var$cleanupScrambleOnScroll(data.current.container);
    $7fe0fc961c0a5700$var$cleanupMarqueeScrollDirection(data.current.container);
    $7fe0fc961c0a5700$var$cleanupImgFly(data.current.container);
    $7fe0fc961c0a5700$var$cleanupPixelateImageRender(data.current.container);
    $7fe0fc961c0a5700$var$cleanupProjectImgWarp(data.current.container);
    $7fe0fc961c0a5700$var$cleanupEffect036Glass(data.current.container);
    data.current.container.style.display = "none";
    if ($7fe0fc961c0a5700$var$onceTl) {
        $7fe0fc961c0a5700$var$onceTl.kill();
        $7fe0fc961c0a5700$var$onceTl = null;
    }
    // Always reset — simpler and covers all navigation paths
    //unicornSceneInitialized = false;
    gsap.killTweensOf(".d-header-container");
    $7fe0fc961c0a5700$var$headerScrollState.isHidden = false;
    data.current.container.querySelectorAll('.mwg_effect002 .card').forEach((card)=>{
        if (card._onMouseMove) window.removeEventListener("mousemove", card._onMouseMove);
    });
    if ($7fe0fc961c0a5700$var$menuIsOpen) {
        $7fe0fc961c0a5700$var$menuIsOpen = false;
        gsap.killTweensOf('.fullNavigation');
        gsap.killTweensOf('.d-fullNav');
        gsap.killTweensOf('.d-overlay');
        gsap.set('.d-fullNav', {
            autoAlpha: 0
        });
        gsap.set('.d-overlay', {
            opacity: 0,
            display: 'none'
        });
        $7fe0fc961c0a5700$var$setMenuClosedState();
        if ($7fe0fc961c0a5700$var$hasLenis) $7fe0fc961c0a5700$var$lenis.start();
    }
});
barba.hooks.afterEnter((data)=>{
    $7fe0fc961c0a5700$var$initAfterEnterFunctions(data.next.container);
    if ($7fe0fc961c0a5700$var$hasLenis) {
        $7fe0fc961c0a5700$var$lenis.resize();
        $7fe0fc961c0a5700$var$lenis.start();
    }
});
barba.init({
    debug: false,
    timeout: 7000,
    preventRunning: true,
    transitions: [
        {
            name: "default",
            sync: false,
            async once (data) {
                $7fe0fc961c0a5700$var$setRealVH();
                $7fe0fc961c0a5700$var$initOnceFunctions();
                return $7fe0fc961c0a5700$var$runPageOnceAnimation(data.next.container);
            },
            async leave (data) {
                return $7fe0fc961c0a5700$var$runPageLeaveAnimation(data.current.container, data.next.container);
            },
            async enter (data) {
                return $7fe0fc961c0a5700$var$runPageEnterAnimation(data.next);
            }
        }
    ]
});
// -----------------------------------------
// GENERIC + HELPERS
// -----------------------------------------
const $7fe0fc961c0a5700$var$themeConfig = {
    light: {
        nav: "dark",
        transition: "light"
    },
    dark: {
        nav: "light",
        transition: "dark"
    }
};
function $7fe0fc961c0a5700$var$applyThemeFrom(container) {
    const pageTheme = container?.dataset?.pageTheme || "light";
    const config = $7fe0fc961c0a5700$var$themeConfig[pageTheme] || $7fe0fc961c0a5700$var$themeConfig.light;
    document.body.dataset.pageTheme = pageTheme;
    const transitionEl = document.querySelector('[data-theme-transition]');
    if (transitionEl) transitionEl.dataset.themeTransition = config.transition;
    const nav = document.querySelector('[data-theme-nav]');
    if (nav) nav.dataset.themeNav = config.nav;
}
function $7fe0fc961c0a5700$var$initLenis() {
    if ($7fe0fc961c0a5700$var$lenis) return;
    if (!$7fe0fc961c0a5700$var$hasLenis) return;
    $7fe0fc961c0a5700$var$lenis = new Lenis({
        lerp: 0.08,
        wheelMultiplier: 0.9,
        smoothWheel: true,
        syncTouch: false,
        syncTouchLerp: 0.5,
        touchMultiplier: 1.1,
        touchInertiaMultiplier: 35
    });
    if ($7fe0fc961c0a5700$var$hasScrollTrigger) $7fe0fc961c0a5700$var$lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time)=>{
        $7fe0fc961c0a5700$var$lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
}
function $7fe0fc961c0a5700$var$resetPage(container) {
    window.scrollTo(0, 0);
    gsap.set(container, {
        clearProps: "position,top,left,right"
    });
    if ($7fe0fc961c0a5700$var$hasLenis) {
        $7fe0fc961c0a5700$var$lenis.resize();
        $7fe0fc961c0a5700$var$lenis.start();
    }
}
function $7fe0fc961c0a5700$var$debounceOnWidthChange(fn, ms) {
    let last = innerWidth, timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>{
            if (innerWidth !== last) {
                last = innerWidth;
                fn.apply(this, args);
            }
        }, ms);
    };
}
function $7fe0fc961c0a5700$var$waitForStableLayout(maxWait = 3000, stableFrames = 3) {
    return new Promise((resolve)=>{
        let lastHeight = document.documentElement.scrollHeight;
        let stableCount = 0;
        const start = performance.now();
        function check() {
            const currentHeight = document.documentElement.scrollHeight;
            if (currentHeight === lastHeight) stableCount++;
            else {
                stableCount = 0;
                lastHeight = currentHeight;
            }
            if (stableCount >= stableFrames || performance.now() - start > maxWait) {
                resolve();
                return;
            }
            requestAnimationFrame(check);
        }
        requestAnimationFrame(check);
    });
}
function $7fe0fc961c0a5700$var$readyForScrollTriggers() {
    const fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    return fontsReady.then(()=>$7fe0fc961c0a5700$var$waitForStableLayout());
}
function $7fe0fc961c0a5700$var$waitUntilVisible(el, cb, maxWait = 2000) {
    // Mobile Chrome in particular can silently reject play() on a muted
    // video if the element has zero size / display:none at the moment
    // play() is called (e.g. still hidden behind Bricks' own
    // '.bricks-lazy-hidden' reveal, which runs asynchronously after the
    // Barba container swap). Poll until it actually has layout, then call
    // back — desktop Chrome is more lenient about this, which is why it
    // can look fine there while mobile fails.
    const start = performance.now();
    function check() {
        const rect = el.getBoundingClientRect();
        const visible = rect.width > 0 && rect.height > 0 && el.offsetParent !== null;
        if (visible || performance.now() - start > maxWait) {
            cb();
            return;
        }
        requestAnimationFrame(check);
    }
    requestAnimationFrame(check);
}
function $7fe0fc961c0a5700$var$initAutoplayVideos(container = document) {
    // Videos inserted into the DOM by Barba (innerHTML swap) don't reliably
    // honor the `autoplay` HTML attribute the way parser-inserted videos do
    // on a hard page load. Explicitly play them once they're live in the DOM.
    const videos = container.querySelectorAll('video[autoplay]');
    videos.forEach((video)=>{
        // Autoplay policies require muted video; make sure it's set regardless
        // of what the markup says, so play() isn't rejected.
        video.muted = true;
        video.playsInline = true;
        const attemptPlay = (isRetry)=>{
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch((err)=>{
                if (isRetry) {
                    // Already retried after confirming visibility — log the real
                    // reason so it's diagnosable (e.g. NotAllowedError from
                    // Chrome's Data Saver / Lite mode, which requires a tap
                    // regardless of what we do here).
                    console.warn('[autoplay] video.play() rejected:', err.name, err.message);
                    return;
                }
                // Most likely cause on mobile: element wasn't visible/laid out
                // yet. Wait for real layout, then retry once.
                $7fe0fc961c0a5700$var$waitUntilVisible(video, ()=>attemptPlay(true));
            });
        };
        if (video.readyState >= 2) attemptPlay(false);
        else {
            video.addEventListener('canplay', ()=>attemptPlay(false), {
                once: true
            });
            // Some browsers need an explicit load() nudge after DOM insertion
            video.load();
        }
    });
}
function $7fe0fc961c0a5700$var$initLazyImageListeners(container = document) {
    const lazyImages = container.querySelectorAll('img[loading="lazy"]');
    if (!lazyImages.length) return;
    let refreshScheduled = false;
    const scheduleRefresh = ()=>{
        if (refreshScheduled) return;
        refreshScheduled = true;
        requestAnimationFrame(()=>{
            refreshScheduled = false;
            if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.resize();
            if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.refresh();
        });
    };
    lazyImages.forEach((img)=>{
        if (img.complete) return;
        // Skip entirely if the box size is already locked by aspect-ratio —
        // loading the image can't shift layout, so a refresh is pure waste.
        const box = img.closest('.d-ct-image, [style*="aspect-ratio"]');
        const lockedByAspectRatio = box && getComputedStyle(box).aspectRatio !== 'auto';
        if (lockedByAspectRatio) return;
        img.addEventListener('load', scheduleRefresh, {
            once: true
        });
    });
}
// -----------------------------------------
// YOUR FUNCTIONS GO BELOW HERE
// -----------------------------------------
// ---------------------------
// Helper Functions
// ---------------------------
function $7fe0fc961c0a5700$var$initAriaCleanup(root = document) {
    const rules = [
        {
            selector: "p",
            attribute: "aria-label"
        },
        {
            selector: ".d-reveal, .d-reveal *, .d-reveal-f, .d-reveal-f *, .d-reveal-vei, .d-reveal-vei *, .d-reveal-content-title, .d-reveal-content-title *, .hero-tag, .hero-tag *",
            attribute: "aria-hidden"
        }
    ];
    const clean = (el)=>{
        rules.forEach((rule)=>{
            if (el.matches?.(rule.selector) && el.hasAttribute(rule.attribute)) el.removeAttribute(rule.attribute);
        });
    };
    const selectors = rules.map((r)=>`${r.selector}[${r.attribute}]`).join(", ");
    root.querySelectorAll(selectors).forEach(clean);
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((m)=>{
            if (m.type === "attributes") clean(m.target);
            if (m.type === "childList") m.addedNodes.forEach((node)=>{
                if (node.nodeType === 1) {
                    clean(node);
                    node.querySelectorAll?.(selectors).forEach(clean);
                }
            });
        });
    });
    observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: rules.map((r)=>r.attribute)
    });
}
function $7fe0fc961c0a5700$var$updateBodyClasses(nextContainer) {
    const nextBodyClass = nextContainer.querySelector('[data-wp-body-class]')?.getAttribute('data-wp-body-class');
    if (!nextBodyClass) return;
    document.body.className = nextBodyClass;
}
// ---------------------------
// Hamburger Menu
// ---------------------------
const $7fe0fc961c0a5700$var$menuBtn = document.getElementById('d-menuBtn');
let $7fe0fc961c0a5700$var$menuIsOpen = false;
let $7fe0fc961c0a5700$var$isMenuAnimating = false; // Lock guard to prevent spam clicking / overlapping timelines
function $7fe0fc961c0a5700$var$setMenuOpenState() {
    $7fe0fc961c0a5700$var$menuIsOpen = true;
    $7fe0fc961c0a5700$var$menuBtn.classList.add('open');
    $7fe0fc961c0a5700$var$menuBtn.setAttribute('aria-expanded', 'true');
    $7fe0fc961c0a5700$var$menuBtn.setAttribute('aria-label', 'Close');
}
function $7fe0fc961c0a5700$var$setMenuClosedState() {
    $7fe0fc961c0a5700$var$menuIsOpen = false;
    $7fe0fc961c0a5700$var$menuBtn.classList.remove('open');
    $7fe0fc961c0a5700$var$menuBtn.setAttribute('aria-expanded', 'false');
    $7fe0fc961c0a5700$var$menuBtn.setAttribute('aria-label', 'Menu');
}
function $7fe0fc961c0a5700$var$openMenuTimeline() {
    if ($7fe0fc961c0a5700$var$isMenuAnimating || $7fe0fc961c0a5700$var$menuIsOpen) return;
    $7fe0fc961c0a5700$var$isMenuAnimating = true;
    if ($7fe0fc961c0a5700$var$hasLenis) $7fe0fc961c0a5700$var$lenis.stop();
    const menuItems = document.querySelectorAll('.mobile-vertical-menu__list li');
    const tl = gsap.timeline({
        onStart: ()=>$7fe0fc961c0a5700$var$setMenuOpenState(),
        onComplete: ()=>{
            $7fe0fc961c0a5700$var$isMenuAnimating = false;
        }
    });
    // initial states
    tl.set('.d-fullNav', {
        clipPath: 'inset(0% 0% 100% 0%)',
        autoAlpha: 1
    });
    tl.set('.d-overlay', {
        display: 'block'
    });
    tl.set(menuItems, {
        yPercent: -100,
        opacity: 0
    });
    tl.to('.d-fullNav', {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 0.6,
        ease: 'power4.out'
    }, 0);
    tl.fromTo('.d-overlay', {
        opacity: 0
    }, {
        opacity: 0.17,
        duration: 0.4,
        ease: 'power1.inOut'
    }, 0);
    tl.to(menuItems, {
        yPercent: 0,
        opacity: 1,
        duration: 0.3,
        stagger: 0.04,
        ease: 'power4.out',
        clearProps: 'transform'
    }, 0.05);
    return tl;
}
function $7fe0fc961c0a5700$var$closeMenuTimeline() {
    if ($7fe0fc961c0a5700$var$isMenuAnimating || !$7fe0fc961c0a5700$var$menuIsOpen) return;
    $7fe0fc961c0a5700$var$isMenuAnimating = true;
    const tl = gsap.timeline({
        onComplete: ()=>{
            $7fe0fc961c0a5700$var$setMenuClosedState();
            gsap.set('.d-fullNav', {
                autoAlpha: 0
            });
            gsap.set('.d-overlay', {
                display: 'none'
            });
            if ($7fe0fc961c0a5700$var$hasLenis) $7fe0fc961c0a5700$var$lenis.start(); // Unlocks scrolling only after the menu slide-away completes
            $7fe0fc961c0a5700$var$isMenuAnimating = false;
        }
    });
    tl.fromTo('.d-fullNav', {
        clipPath: 'inset(0% 0% 0% 0%)'
    }, {
        clipPath: 'inset(0% 0% 100% 0%)',
        duration: 0.5,
        ease: "power4.out"
    });
    tl.to('.d-overlay', {
        opacity: 0,
        duration: 0.3,
        ease: "power1.inOut"
    }, "<");
    return tl;
}
function $7fe0fc961c0a5700$var$toggleMenu() {
    if ($7fe0fc961c0a5700$var$isMenuAnimating) return; // Ignore clicks while an animation is playing
    if ($7fe0fc961c0a5700$var$menuIsOpen) $7fe0fc961c0a5700$var$closeMenuTimeline();
    else $7fe0fc961c0a5700$var$openMenuTimeline();
}
window.toggleMenu = $7fe0fc961c0a5700$var$toggleMenu;
document.addEventListener('click', (e)=>{
    if (!$7fe0fc961c0a5700$var$menuIsOpen || $7fe0fc961c0a5700$var$isMenuAnimating) return; // Ignore if closed or currently mid-animation
    const nav = document.querySelector('.d-fullNav');
    if (nav && !nav.contains(e.target) && !$7fe0fc961c0a5700$var$menuBtn.contains(e.target)) $7fe0fc961c0a5700$var$closeMenuTimeline();
});
// ---------------------------
// Header Hide/Show on Scroll
// ---------------------------
const $7fe0fc961c0a5700$var$headerScrollState = {
    isHidden: false
};
let $7fe0fc961c0a5700$var$headerScrollInitialized = false;
let $7fe0fc961c0a5700$var$headerLenisCallback = null;
function $7fe0fc961c0a5700$var$initHeaderScroll() {
    const header1 = document.querySelectorAll('.d-header-container'); // both layers
    if (!header1.length || !$7fe0fc961c0a5700$var$lenis) return;
    // Clean up previous Lenis callback if present
    if ($7fe0fc961c0a5700$var$headerLenisCallback) $7fe0fc961c0a5700$var$lenis.off('scroll', $7fe0fc961c0a5700$var$headerLenisCallback);
    const hideHeader = ()=>{
        if ($7fe0fc961c0a5700$var$headerScrollState.isHidden || $7fe0fc961c0a5700$var$menuIsOpen) return;
        $7fe0fc961c0a5700$var$headerScrollState.isHidden = true;
        gsap.to(header1, {
            autoAlpha: 0,
            duration: 0.3,
            ease: "power2.inOut",
            overwrite: "auto"
        });
    };
    const showHeader = ()=>{
        if (!$7fe0fc961c0a5700$var$headerScrollState.isHidden) return;
        $7fe0fc961c0a5700$var$headerScrollState.isHidden = false;
        gsap.to(header1, {
            autoAlpha: 1,
            duration: 0.3,
            ease: "power2.inOut",
            overwrite: "auto"
        });
    };
    let lastScroll = $7fe0fc961c0a5700$var$lenis.scroll || 0;
    $7fe0fc961c0a5700$var$headerLenisCallback = ({ scroll: scroll })=>{
        // Avoid triggering while the hero intro animation is executing or menu is open
        if ($7fe0fc961c0a5700$var$heroPinDeferred || $7fe0fc961c0a5700$var$menuIsOpen) return;
        const delta = scroll - lastScroll;
        // Small threshold (e.g., 5px) to prevent trackpad micro-jitter
        if (Math.abs(delta) > 5) {
            if (delta > 0 && scroll > 40) // Scrolling down (and past a tiny initial buffer so it doesn't hide immediately at the very top)
            hideHeader();
            else if (delta < 0) // Scrolling up
            showHeader();
            lastScroll = scroll;
        }
    };
    $7fe0fc961c0a5700$var$lenis.on('scroll', $7fe0fc961c0a5700$var$headerLenisCallback);
    $7fe0fc961c0a5700$var$headerScrollInitialized = true;
}
// ---------------------------
// Menu Update
// ---------------------------
function $7fe0fc961c0a5700$var$updateActiveMenu() {
    const currentPath = window.location.pathname;
    const allMenuLinks = document.querySelectorAll('.horizontal-menu a, .vertical-menu-1 a, .vertical-menu-2 a, .vertical-menu-3 a, .mobile-vertical-menu a');
    allMenuLinks.forEach((link)=>{
        link.classList.remove('current-menu-item', 'current_page_item', 'current-page-ancestor', 'current_page_ancestor', 'current_page_parent', 'active');
        const parentLi = link.closest('li');
        if (parentLi) parentLi.classList.remove('current-menu-item', 'current_page_item', 'current-page-ancestor', 'current_page_ancestor', 'current_page_parent', 'active');
    });
    let foundExactMatch = false;
    allMenuLinks.forEach((link)=>{
        const linkPath = new URL(link.href, window.location.origin).pathname;
        if (linkPath === currentPath) {
            foundExactMatch = true;
            link.classList.add('current-menu-item', 'active');
            const parentLi = link.closest('li');
            if (parentLi) parentLi.classList.add('current-menu-item', 'active');
        }
    });
    if (!foundExactMatch) {
        const normalizedCurrentPath = currentPath.replace(/\/$/, '');
        allMenuLinks.forEach((link)=>{
            const linkPath = new URL(link.href, window.location.origin).pathname;
            const normalizedLinkPath = linkPath.replace(/\/$/, '');
            if (normalizedCurrentPath.startsWith(normalizedLinkPath + '/') && normalizedLinkPath.length > 1) {
                link.classList.add('current-page-ancestor', 'current_page_ancestor', 'active');
                const parentLi = link.closest('li');
                if (parentLi) parentLi.classList.add('current-page-ancestor', 'current_page_ancestor', 'active');
            }
        });
    }
}
document.addEventListener('DOMContentLoaded', $7fe0fc961c0a5700$var$updateActiveMenu);
// ---------------------------
// Fade in Images
// ---------------------------
function $7fe0fc961c0a5700$var$fadeInImages(container = document) {
    const images = container.querySelectorAll('.fade-image');
    images.forEach((img)=>{
        gsap.set(img, {
            scale: 1,
            opacity: 1
        });
        const wrapper = img.parentElement; // .d-ct-img-bl / -tl / -tr
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: img,
                start: "top 70%",
                toggleActions: "play none none none",
                onEnter: ()=>wrapper?.classList.add('is-animating')
            },
            onComplete: ()=>wrapper?.classList.remove('is-animating')
        });
        tl.from(img, {
            scale: 1.15,
            opacity: 0,
            duration: 0.7,
            ease: "power4.out",
            force3D: true
        });
        img._revealTL = tl;
    });
}
// ---------------------------
// Main Effect 2 on Text
// ---------------------------
function $7fe0fc961c0a5700$var$dFadeTextLine(container = document) {
    const mq = window.matchMedia("(min-width: 769px)");
    if (!mq.matches) return;
    const elements = container.querySelectorAll(".d-reveal-f");
    if (!elements.length) return;
    // Defer execution by 1 frame to guarantee Barba unpins 'position: fixed' 
    // and the page is in standard document layout flow.
    requestAnimationFrame(()=>{
        elements.forEach((element)=>{
            // Avoid duplicated triggers on re-runs
            if (element._revealTL) {
                element._revealTL.scrollTrigger?.kill();
                element._revealTL.kill();
            }
            gsap.set(element, {
                opacity: 1
            });
            SplitText.create(element, {
                type: "lines",
                autoSplit: true,
                mask: "lines",
                onSplit: (self)=>{
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            start: "top 85%",
                            toggleActions: "play none none none"
                        }
                    });
                    tl.from(self.lines, {
                        duration: 0.8,
                        opacity: 0,
                        stagger: 0.08,
                        ease: "power4.out"
                    });
                    element._splitText = self;
                    element._revealTL = tl;
                    return tl;
                }
            });
        });
        // Refresh once for all text elements AFTER layout calculations finalize
        if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupdFadeTextLine(container) {
    if (!container) return;
    const elements = container.querySelectorAll(".d-reveal-f");
    elements.forEach((element)=>{
        if (element._splitText) {
            try {
                element._splitText.revert();
            } catch (e) {
                console.warn(e);
            }
            element._splitText = null;
        }
        if (element._revealTL) {
            element._revealTL.kill();
            element._revealTL = null;
        }
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$reInitScripts(container = document) {
    container.querySelectorAll('.accordion-toggle').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            btn.nextElementSibling.classList.toggle('open');
        });
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$reEvalInlineScripts(container) {
    container.querySelectorAll('script').forEach((script)=>{
        const newScript = document.createElement('script');
        if (script.src) newScript.src = script.src;
        else newScript.innerHTML = script.innerHTML;
        document.body.appendChild(newScript);
        script.remove();
    });
}
/* ---------------------------
   2.1 Bricks & Layout Helpers
--------------------------- */ function $7fe0fc961c0a5700$var$reinitBricksFrontend() {
    if (window.bricksFrontend && typeof window.bricksFrontend.init === 'function') window.bricksFrontend.init();
}
// ---------------------------
// D26 PROJECT Effect 036
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect036(container = document) {
    container.querySelectorAll('.mwg_effect036').forEach($7fe0fc961c0a5700$var$setupEffect036);
}
function $7fe0fc961c0a5700$var$setupEffect036(root) {
    if (root._destroyEffect036) return; // avoid double-init
    const urls = Array.from(root.querySelectorAll('.medias img')).map((el)=>el.getAttribute('src')).filter(Boolean);
    const hoverEls = Array.from(root.querySelectorAll('.sentence .hover'));
    if (!urls.length || !hoverEls.length) return;
    const SPAWN_EVERY = 0.6; // seconds between images while hovering
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let incr = 0;
    let hovering = false;
    let loopCall = null;
    let lastSpawn = 0; // performance.now() of the last spawn
    let heldImg = null; // the image currently resting on screen
    let heldEl = hoverEls[0]; // the .hover element the held image is anchored to
    let currentEl = hoverEls[0];
    const rand = (n)=>(Math.random() - 0.5) * n;
    // Warm the cache only when this block gets close to the viewport
    const io = new IntersectionObserver(([entry])=>{
        if (!entry.isIntersecting) return;
        io.disconnect();
        urls.forEach((src)=>{
            const i = new Image();
            i.src = src;
            i.decode?.().catch(()=>{});
        });
    }, {
        rootMargin: '400px 0px'
    });
    io.observe(root);
    // Same coordinate logic as before (viewport X, document-relative Y)
    function getPoint(el) {
        const b = el.getBoundingClientRect();
        const scrollY = $7fe0fc961c0a5700$var$lenis ? $7fe0fc961c0a5700$var$lenis.scroll : window.scrollY;
        return {
            x: b.left + b.width / 2,
            y: b.top + b.height / 2 + scrollY
        };
    }
    function createImg(src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.dataset.effect036 = '';
        root.appendChild(img);
        return img;
    }
    // Out animation: only ever played when the next image replaces this one
    function releaseImage(img) {
        gsap.to(img, {
            scale: 0.9,
            duration: 0.2,
            ease: 'back.in(1.7)',
            overwrite: 'auto',
            onComplete: ()=>img.remove()
        });
    }
    // Spawns the next image, and sends the previously held one out
    function spawnImage(initial = false) {
        const prev = heldImg;
        const { x: x, y: y } = getPoint(currentEl);
        const image = createImg(urls[incr % urls.length]);
        incr++;
        heldImg = image;
        heldEl = currentEl;
        lastSpawn = performance.now();
        if (prev) releaseImage(prev);
        if (initial && $7fe0fc961c0a5700$var$reducedMotion) {
            gsap.set(image, {
                xPercent: -50,
                yPercent: -50,
                x: x,
                y: y,
                rotation: rand(10)
            });
            return;
        }
        const from = {
            xPercent: -50,
            yPercent: -50,
            x: x + rand(50),
            y: y + 50,
            rotation: rand(10)
        };
        const to = {
            y: y,
            rotation: rand(10),
            ease: 'back.out(1.7)',
            duration: 0.6
        };
        // First image on page load pops in from scale 0
        if (initial) {
            from.scale = 0;
            to.scale = 1;
        }
        gsap.fromTo(image, from, to);
    }
    // ---------- Spawn loop ----------
    // Stopping the loop never touches the held image, so its in animation
    // always completes and it stays on screen until the next hover.
    function loop() {
        if (!hovering) return;
        spawnImage();
        loopCall = gsap.delayedCall(SPAWN_EVERY, loop);
    }
    function startImages(el) {
        currentEl = el;
        hovering = true;
        loopCall?.kill();
        // If we re-enter quickly, respect the spawn rhythm instead of spamming
        const elapsed = (performance.now() - lastSpawn) / 1000;
        const wait = Math.max(0, SPAWN_EVERY - elapsed);
        loopCall = gsap.delayedCall(wait, loop);
    }
    function stopImages() {
        hovering = false;
        loopCall?.kill();
        loopCall = null;
    }
    // Keep the held image aligned if layout shifts
    function placeHeld() {
        if (!heldImg || gsap.isTweening(heldImg)) return;
        const { x: x, y: y } = getPoint(heldEl);
        gsap.set(heldImg, {
            x: x,
            y: y
        });
    }
    // ---------- Listeners ----------
    const handlers = [];
    if (canHover && !$7fe0fc961c0a5700$var$reducedMotion) hoverEls.forEach((el)=>{
        const onEnter = ()=>startImages(el);
        const onLeave = ()=>stopImages();
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);
        handlers.push({
            el: el,
            onEnter: onEnter,
            onLeave: onLeave
        });
    });
    const onResize = $7fe0fc961c0a5700$var$debounceOnWidthChange(placeHeld, 200);
    window.addEventListener('resize', onResize);
    if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.addEventListener('refresh', placeHeld);
    // Initial state: first image on screen
    spawnImage(true);
    // ---------- Cleanup (called from Barba afterLeave) ----------
    root._destroyEffect036 = ()=>{
        io.disconnect();
        hovering = false;
        loopCall?.kill();
        loopCall = null;
        root.querySelectorAll('img[data-effect036]').forEach((img)=>{
            gsap.killTweensOf(img);
            img.remove();
        });
        heldImg = null;
        handlers.forEach(({ el: el, onEnter: onEnter, onLeave: onLeave })=>{
            el.removeEventListener('mouseenter', onEnter);
            el.removeEventListener('mouseleave', onLeave);
        });
        handlers.length = 0;
        window.removeEventListener('resize', onResize);
        if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.removeEventListener('refresh', placeHeld);
        root._destroyEffect036 = null;
    };
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect036(container) {
    if (!container) return;
    container.querySelectorAll('.mwg_effect036').forEach((root)=>{
        root._destroyEffect036?.();
    });
}
// ---------------------------
// End 036
// ---------------------------
// ---------------------------
// Hexagon Image Reveal (Right)
// ---------------------------
function $7fe0fc961c0a5700$var$initHexRevealR(container = document) {
    const blocks = container.querySelectorAll('.hex-block-r');
    blocks.forEach((block)=>{
        const wrap = block.querySelector('.hex-wrap-r');
        const img = block.querySelector('.hex-r img');
        if (!wrap || !img) return;
        gsap.set(block, {
            opacity: 1
        });
        gsap.set(wrap, {
            rotate: -17
        });
        gsap.set(img, {
            opacity: 0,
            rotate: 17
        });
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
        tl.to(wrap, {
            rotate: 6,
            duration: 0.9,
            ease: "power2.inOut"
        });
        tl.to(img, {
            opacity: 1,
            rotate: -6,
            duration: 0.9,
            ease: "power2.inOut"
        }, "<");
        block._revealTL = tl;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupHexRevealR(container) {
    if (!container) return;
    const blocks = container.querySelectorAll('.hex-block-r');
    blocks.forEach((block)=>{
        if (block._revealTL) {
            block._revealTL.kill();
            block._revealTL = null;
        }
    });
}
// ---------------------------
// Hexagon Image Reveal (Left)
// ---------------------------
function $7fe0fc961c0a5700$var$initHexRevealL(container = document) {
    const blocks = container.querySelectorAll('.hex-block-l');
    blocks.forEach((block)=>{
        const wrap = block.querySelector('.hex-wrap-l');
        const img = block.querySelector('.hex-l img');
        if (!wrap || !img) return;
        gsap.set(block, {
            opacity: 1
        });
        gsap.set(wrap, {
            rotate: 21
        });
        gsap.set(img, {
            opacity: 0,
            rotate: -21
        });
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
        tl.to(wrap, {
            rotate: -4,
            duration: 0.9,
            ease: "power2.inOut"
        });
        tl.to(img, {
            opacity: 1,
            rotate: 4,
            duration: 0.9,
            ease: "power2.inOut"
        }, "<");
        block._revealTL = tl;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupHexRevealL(container) {
    if (!container) return;
    const blocks = container.querySelectorAll('.hex-block-l');
    blocks.forEach((block)=>{
        if (block._revealTL) {
            block._revealTL.kill();
            block._revealTL = null;
        }
    });
}
// CT
// ---------------------------
// Hero Sticky Pin Reveal
// ---------------------------
let $7fe0fc961c0a5700$var$heroPinDeferred = false;
// GRADIENT WAVE TEXT
function $7fe0fc961c0a5700$var$initGradientWaveText(container = document) {
    const headings = container.querySelectorAll('[data-gradient-wave-text]');
    if (!headings.length) return;
    $7fe0fc961c0a5700$var$readyForScrollTriggers().then(()=>{
        headings.forEach((heading)=>{
            if (heading._gradientWaveInit) return;
            heading._gradientWaveInit = true;
            const scrollStart = heading.getAttribute('data-gradient-wave-scroll-start') || 'top 90%';
            const scrollEnd = heading.getAttribute('data-gradient-wave-scroll-end') || 'center 40%';
            const startColor = heading.getAttribute('data-gradient-wave-color-start') || 'rgba(18, 18, 18, 0.6)';
            const waveColor = heading.getAttribute('data-gradient-wave-color-wave') || '#c77530';
            const waveDuration = parseFloat(heading.getAttribute('data-gradient-wave-duration')) || 0.4;
            const scrubValue = parseFloat(heading.getAttribute('data-gradient-wave-scrub')) || 0.1;
            const endColor = getComputedStyle(heading).color;
            const mm = gsap.matchMedia();
            mm.add('(min-width: 960px)', ()=>{
                new SplitText(heading, {
                    type: 'lines',
                    autoSplit: true,
                    onSplit (self) {
                        const lines = self.lines;
                        const activeLines = new Set();
                        let maxProgress = 0;
                        let isReady = false;
                        const syncLines = (progressValue)=>{
                            const activeCount = Math.round(progressValue * lines.length);
                            lines.forEach((line, index)=>{
                                const isActive = index < activeCount;
                                gsap.killTweensOf(line);
                                gsap.set(line, {
                                    color: isActive ? endColor : startColor
                                });
                                if (isActive) activeLines.add(line);
                                else activeLines.delete(line);
                            });
                        };
                        gsap.set(lines, {
                            color: startColor
                        });
                        const st = ScrollTrigger.create({
                            trigger: heading,
                            start: scrollStart,
                            end: scrollEnd,
                            scrub: scrubValue,
                            onRefresh: ()=>{
                                isReady = false;
                                syncLines(maxProgress);
                                requestAnimationFrame(()=>{
                                    isReady = true;
                                });
                            },
                            onUpdate: (self)=>{
                                if (!isReady) return;
                                if (self.progress <= maxProgress) return;
                                maxProgress = self.progress;
                                const activeCount = Math.round(maxProgress * lines.length);
                                lines.forEach((line, index)=>{
                                    const isActive = index < activeCount;
                                    if (isActive && !activeLines.has(line)) {
                                        activeLines.add(line);
                                        gsap.killTweensOf(line);
                                        gsap.timeline().to(line, {
                                            color: waveColor,
                                            duration: waveDuration * 0.3,
                                            ease: 'power2.out'
                                        }).to(line, {
                                            color: endColor,
                                            duration: waveDuration * 0.7,
                                            ease: 'power2.in'
                                        });
                                    }
                                });
                                if (maxProgress >= 1) self.kill();
                            }
                        });
                        heading._gradientWaveST = st;
                        heading._gradientWaveSplit = self;
                    }
                });
            });
            heading._gradientWaveMM = mm;
        });
        if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupGradientWaveText(container) {
    if (!container) return;
    container.querySelectorAll('[data-gradient-wave-text]').forEach((heading)=>{
        if (heading._gradientWaveMM) {
            heading._gradientWaveMM.revert();
            heading._gradientWaveMM = null;
        }
        if (heading._gradientWaveSplit) {
            try {
                heading._gradientWaveSplit.revert();
            } catch (e) {
                console.warn(e);
            }
            heading._gradientWaveSplit = null;
        }
        heading._gradientWaveST = null;
        heading._gradientWaveInit = false; // allow re-init on next Barba enter
    });
}
// ---------------------------
// Main Effect on Text
// ---------------------------
function $7fe0fc961c0a5700$var$dRevealTextLine(container = document) {
    const elements = container.querySelectorAll(".d-reveal");
    if (!elements.length) return;
    $7fe0fc961c0a5700$var$readyForScrollTriggers().then(()=>{
        elements.forEach((element)=>{
            if (element._revealTL) {
                element._revealTL.scrollTrigger?.kill();
                element._revealTL.kill();
            }
            gsap.set(element, {
                opacity: 1
            });
            SplitText.create(element, {
                type: "lines",
                autoSplit: true,
                mask: "lines",
                onSplit: (self)=>{
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            start: "top 85%",
                            toggleActions: "play none none none"
                        }
                    });
                    tl.from(self.lines, {
                        duration: 0.6,
                        opacity: 0,
                        stagger: 0.06,
                        ease: "power2.out"
                    });
                    element._splitText = self;
                    element._revealTL = tl;
                    return tl;
                }
            });
        });
        if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupdRevealTextLine(container) {
    if (!container) return;
    const elements = container.querySelectorAll(".d-reveal");
    elements.forEach((element)=>{
        if (element._splitText) {
            try {
                element._splitText.revert();
            } catch (e) {
                console.warn(e);
            }
            element._splitText = null;
        }
        if (element._revealTL) {
            element._revealTL.kill();
            element._revealTL = null;
        }
    });
}
// ---------------------------
// Dual Stack Flip (Effect 056)
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect056(container = document) {
    const roots = container.querySelectorAll('.mwg_effect056');
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    roots.forEach((root)=>{
        // Avoid double-init if this ever runs twice on the same root
        if (root._destroyEffect056) return;
        const pinHeight = root.querySelector('.pin-height');
        const containerWrapper = root.querySelector('.d-ct-wrapper');
        const containerEl = root.querySelector('.container');
        const mediasA = root.querySelector('.medias-a');
        const mediasB = root.querySelector('.medias-b');
        if (!pinHeight || !containerEl || !mediasA || !mediasB) return;
        const itemsA = mediasA.querySelectorAll('.media');
        const itemsB = mediasB.querySelectorAll('.media');
        const stepsCount = itemsA.length;
        if (!stepsCount) return;
        let currentStep = -1;
        function setVisible(index) {
            itemsA.forEach((m, i)=>m.style.visibility = i === index ? 'visible' : 'hidden');
            itemsB.forEach((m, i)=>m.style.visibility = i === index ? 'visible' : 'hidden');
        }
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: pinHeight,
                start: 'top top',
                end: 'bottom bottom',
                pin: containerWrapper,
                scrub: 0.5,
                ...isDesktop && {
                    pinType: 'transform'
                },
                anticipatePin: 1,
                onUpdate: (self)=>{
                    const step = Math.round(self.progress * (stepsCount - 1));
                    if (step !== currentStep) {
                        setVisible(step);
                        currentStep = step;
                    }
                }
            }
        });
        gsap.set(mediasA, {
            xPercent: -60
        });
        gsap.set(mediasB, {
            xPercent: 60
        });
        for(let i = 0; i < stepsCount - 1; i++){
            const dirA = i % 2 === 0 ? 1 : -1;
            tl.to(mediasA, {
                xPercent: dirA * 60,
                rotateY: '+=180',
                duration: 1,
                ease: 'power2.inOut'
            });
            tl.to(mediasA, {
                z: -150,
                duration: 0.5,
                yoyo: true,
                repeat: 1,
                ease: 'power2.inOut'
            }, '<');
            tl.to(mediasB, {
                xPercent: -dirA * 60,
                rotateY: '-=180',
                duration: 1,
                ease: 'power2.inOut'
            }, '<');
            tl.to(mediasB, {
                z: 150,
                duration: 0.5,
                yoyo: true,
                repeat: 1,
                ease: 'power2.inOut'
            }, '<');
            const rx = (Math.random() - 0.5) * 40;
            const rz = (Math.random() - 0.5) * 40;
            tl.to([
                mediasA,
                mediasB
            ], {
                rotateX: rx,
                rotateZ: rz,
                scale: 1.1,
                duration: 0.5,
                repeat: 1,
                yoyo: true,
                ease: 'power2.in'
            }, '<');
        }
        // Store cleanup so Barba can tear this down on page leave
        root._destroyEffect056 = ()=>{
            tl.scrollTrigger?.kill();
            tl.kill();
            root._destroyEffect056 = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect056(container) {
    if (!container) return;
    container.querySelectorAll('.mwg_effect056').forEach((root)=>{
        root._destroyEffect056?.();
    });
}
// ---------------------------
// 3D Perspective Image Reveal
// ---------------------------
function $7fe0fc961c0a5700$var$init3DPV(container = document) {
    const wrappers = container.querySelectorAll('.d-3dpv');
    if (!wrappers.length) return;
    wrappers.forEach((wrapper)=>{
        const img = wrapper.querySelector('img');
        gsap.fromTo(wrapper, {
            clipPath: 'inset(25% 25% 0% 25%)'
        }, {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'punch',
            duration: 1.8,
            scrollTrigger: {
                trigger: wrapper,
                start: 'top 80%'
            }
        });
        if (img) gsap.fromTo(img, {
            scale: 1.6
        }, {
            scale: 1,
            ease: 'punch',
            duration: 1.8,
            scrollTrigger: {
                trigger: wrapper,
                start: 'top 80%'
            }
        });
    });
}
// ---------------------------
// Media Fly-Out Reveal (Effect 082)
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect082(container = document) {
    const roots = container.querySelectorAll('.mwg_effect082');
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    roots.forEach((root)=>{
        // Avoid double-init if this ever runs twice on the same root
        if (root._destroyEffect082) return;
        const pinHeight = root.querySelector('.pin-height');
        const containerWrapper = root.querySelector('.d-ct-wrapper');
        const containerEl = root.querySelector('.container');
        const medias = root.querySelectorAll('.media');
        if (!pinHeight || !containerEl || !medias.length) return;
        const scrollEls = root.querySelectorAll('.scroll');
        const scrollFade = gsap.to(scrollEls, {
            autoAlpha: 0,
            duration: 0.2,
            scrollTrigger: {
                trigger: root,
                start: 'top top',
                end: 'top top-=1',
                toggleActions: 'play none reverse none'
            }
        });
        const revealTimelines = [];
        medias.forEach((media, index)=>{
            const tlReveal = gsap.timeline({
                paused: true
            });
            tlReveal.set(media, {
                autoAlpha: 1
            }, 'media' + index);
            tlReveal.fromTo(media, {
                scaleX: 0.9,
                scaleY: 0.9
            }, {
                scaleX: 1,
                scaleY: 1,
                immediateRender: false,
                ease: 'elastic.out(2, 0.6)',
                duration: 0.5
            }, '<');
            revealTimelines.push(tlReveal);
        });
        const master = gsap.timeline({
            scrollTrigger: {
                trigger: pinHeight,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 0.5,
                pin: containerWrapper,
                ...isDesktop && {
                    pinType: 'transform'
                },
                anticipatePin: 1
            }
        });
        const stepTimelines = [];
        medias.forEach((media, i)=>{
            const isLast = i === medias.length - 1;
            const tl = gsap.timeline({
                onStart: ()=>{
                    revealTimelines[i].play();
                },
                onReverseComplete: ()=>{
                    revealTimelines[i].progress(-1).pause();
                }
            });
            const angle = (Math.random() - 0.5) * 17;
            tl.to(media, {
                z: -window.innerWidth / 37,
                rotation: angle,
                duration: 1,
                ease: 'power1.inOut'
            });
            if (!isLast) tl.to(media, {
                x: angle * 0.01 * window.innerWidth,
                y: -2 * window.innerHeight,
                duration: 0.6,
                ease: 'power1.in'
            }, '<+=0.4');
            stepTimelines.push(tl);
            master.add(tl, 0.1 * i);
        });
        // Store cleanup so Barba can tear this down on page leave
        root._destroyEffect082 = ()=>{
            scrollFade.scrollTrigger?.kill();
            scrollFade.kill();
            revealTimelines.forEach((tl)=>tl.kill());
            stepTimelines.forEach((tl)=>tl.kill());
            master.scrollTrigger?.kill();
            master.kill();
            root._destroyEffect082 = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect082(container) {
    if (!container) return;
    container.querySelectorAll('.mwg_effect082').forEach((root)=>{
        root._destroyEffect082?.();
    });
}
// ---------------------------
// Directional List Hover OSMO
// ---------------------------
function $7fe0fc961c0a5700$var$getDirectionalHoverDirection(event, el, type) {
    const { left: left, top: top, width: w, height: h } = el.getBoundingClientRect();
    const x = event.clientX - left;
    const y = event.clientY - top;
    if (type === 'y') return y < h / 2 ? 'top' : 'bottom';
    if (type === 'x') return x < w / 2 ? 'left' : 'right';
    const distances = {
        top: y,
        right: w - x,
        bottom: h - y,
        left: x
    };
    return Object.entries(distances).reduce((a, b)=>a[1] < b[1] ? a : b)[0];
}
function $7fe0fc961c0a5700$var$initDirectionalListHover(container = document) {
    const directionMap = {
        top: 'translateY(-100%)',
        bottom: 'translateY(100%)',
        left: 'translateX(-100%)',
        right: 'translateX(100%)'
    };
    container.querySelectorAll('[data-directional-hover]').forEach((wrapper)=>{
        const type = wrapper.getAttribute('data-type') || 'all';
        wrapper.querySelectorAll('[data-directional-hover-item]').forEach((item)=>{
            const tile = item.querySelector('[data-directional-hover-tile]');
            if (!tile) return;
            item.addEventListener('mouseenter', (e)=>{
                const dir = $7fe0fc961c0a5700$var$getDirectionalHoverDirection(e, item, type);
                tile.style.transition = 'none';
                tile.style.transform = directionMap[dir] || 'translate(0, 0)';
                tile.offsetHeight;
                tile.style.transition = '';
                tile.style.transform = 'translate(0%, 0%)';
                item.setAttribute('data-status', `enter-${dir}`);
            });
            item.addEventListener('mouseleave', (e)=>{
                const dir = $7fe0fc961c0a5700$var$getDirectionalHoverDirection(e, item, type);
                item.setAttribute('data-status', `leave-${dir}`);
                tile.style.transform = directionMap[dir] || 'translate(0, 0)';
            });
        });
    });
}
// ---------------------------
// Directional Hover List Reveal (on scroll)
// ---------------------------
function $7fe0fc961c0a5700$var$initDirectionalHoverReveal(container = document) {
    const wrappers = container.querySelectorAll('[data-directional-hover]');
    wrappers.forEach((wrapper)=>{
        // Avoid double-init if this ever runs twice on the same wrapper
        if (wrapper._directionalHoverRevealTL) return;
        const items = wrapper.querySelectorAll('[data-directional-hover-item]');
        if (!items.length) return;
        gsap.set(items, {
            opacity: 0,
            y: 60
        });
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'top 80%',
                toggleActions: 'play none none none'
            }
        });
        tl.to(items, {
            y: 0,
            opacity: 1,
            duration: 0.5,
            stagger: 0.1,
            ease: 'power2.out'
        });
        wrapper._directionalHoverRevealTL = tl;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupDirectionalHoverReveal(container) {
    if (!container) return;
    container.querySelectorAll('[data-directional-hover]').forEach((wrapper)=>{
        if (wrapper._directionalHoverRevealTL) {
            wrapper._directionalHoverRevealTL.scrollTrigger?.kill();
            wrapper._directionalHoverRevealTL.kill();
            wrapper._directionalHoverRevealTL = null;
        }
    });
}
// ---------------------------
// Ink Mask Reveal
// ---------------------------
function $7fe0fc961c0a5700$var$initInkMask(container = document) {
    const masks = container.querySelectorAll('.ink-mask');
    masks.forEach((wrap)=>{
        // Prevent duplicate initialization on the same element
        if (wrap._inkTick) return;
        const circle = wrap.querySelector('#inkCircle') || wrap.querySelector('circle');
        if (!circle) return;
        const VB_W = 640, VB_H = 490;
        let targetR = 0, currentR = 0;
        let targetX = VB_W / 2, targetY = VB_H / 2;
        let currentX = targetX, currentY = targetY;
        let animId = null;
        function setFromEvent(e) {
            const rect = wrap.getBoundingClientRect();
            targetX = (e.clientX - rect.left) / rect.width * VB_W;
            targetY = (e.clientY - rect.top) / rect.height * VB_H;
            targetR = 140;
        }
        const onMouseEnter = ()=>{};
        const onMouseLeave = ()=>{
            targetR = 0;
        };
        const onTouchMove = (e)=>{
            setFromEvent(e.touches[0]);
            e.preventDefault();
        };
        const onTouchEnd = ()=>{
            targetR = 0;
        };
        wrap.addEventListener('mousemove', setFromEvent);
        wrap.addEventListener('mouseleave', onMouseLeave);
        wrap.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
        wrap.addEventListener('touchend', onTouchEnd);
        function tick() {
            currentR += (targetR - currentR) * 0.12;
            currentX += (targetX - currentX) * 0.18;
            currentY += (targetY - currentY) * 0.18;
            circle.setAttribute('r', currentR.toFixed(2));
            circle.setAttribute('cx', currentX.toFixed(2));
            circle.setAttribute('cy', currentY.toFixed(2));
            animId = requestAnimationFrame(tick);
            wrap._inkTick = animId;
        }
        // Save event references for teardown
        wrap._inkEvents = {
            setFromEvent: setFromEvent,
            onMouseLeave: onMouseLeave,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        };
        tick();
    });
}
function $7fe0fc961c0a5700$var$destroyInkMask(container = document) {
    const masks = container.querySelectorAll('.ink-mask');
    masks.forEach((wrap)=>{
        if (wrap._inkTick) {
            cancelAnimationFrame(wrap._inkTick);
            delete wrap._inkTick;
        }
        if (wrap._inkEvents) {
            const { setFromEvent: setFromEvent, onMouseLeave: onMouseLeave, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd } = wrap._inkEvents;
            wrap.removeEventListener('mousemove', setFromEvent);
            wrap.removeEventListener('mouseleave', onMouseLeave);
            wrap.removeEventListener('touchmove', onTouchMove);
            wrap.removeEventListener('touchend', onTouchEnd);
            delete wrap._inkEvents;
        }
    });
}
// CT IMAGE LIGHTNOX ZOOM
let $7fe0fc961c0a5700$var$clickZoomInitialized = false;
let $7fe0fc961c0a5700$var$clickZoomForceClose = null; // exposed for Barba afterLeave
function $7fe0fc961c0a5700$var$initClickToZoomBasic() {
    if ($7fe0fc961c0a5700$var$clickZoomInitialized) return;
    $7fe0fc961c0a5700$var$clickZoomInitialized = true;
    const CONFIG = {
        openDuration: 0.5,
        closeDuration: 0.5,
        openEase: "power3.out",
        closeEase: "power3.out",
        closeOnScroll: true,
        closeOnEscape: true,
        closeOnClick: true
    };
    // Only active on displays wider than 960px
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    const lightbox = document.querySelector("[data-click-zoom-lightbox]");
    if (!lightbox) return;
    lightbox.setAttribute("role", "dialog");
    lightbox.setAttribute("aria-modal", "true");
    lightbox.setAttribute("aria-hidden", "true");
    // Backdrop animates from transparent to the CSS-declared color.
    const backdropColor = window.getComputedStyle(lightbox).backgroundColor;
    const transparent = "rgba(254,251,244,0)";
    let cloneEl = null;
    let isOpen = false;
    let isAnimating = false;
    let openScrollY = 0;
    let openSourceRectDoc = null;
    function currentScrollY() {
        return $7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis ? $7fe0fc961c0a5700$var$lenis.scroll : window.scrollY;
    }
    function computeFlip(src, dst) {
        return {
            scaleX: src.width / dst.width,
            scaleY: src.height / dst.height,
            tx: src.left + src.width / 2 - (dst.left + dst.width / 2),
            ty: src.top + src.height / 2 - (dst.top + dst.height / 2)
        };
    }
    function open(img) {
        if (!mediaQuery.matches) return; // skip below 960px
        if (isOpen || isAnimating) return;
        if (!img.complete || !img.naturalWidth) return;
        isAnimating = true;
        openScrollY = currentScrollY();
        const srcRect = img.getBoundingClientRect();
        openSourceRectDoc = {
            top: srcRect.top + openScrollY,
            left: srcRect.left,
            width: srcRect.width,
            height: srcRect.height
        };
        cloneEl = img.cloneNode(false);
        cloneEl.loading = "eager";
        cloneEl.removeAttribute("data-click-zoom");
        const srcComputed = window.getComputedStyle(img);
        gsap.set(lightbox, {
            display: "flex",
            backgroundColor: transparent
        });
        const lightboxStyle = window.getComputedStyle(lightbox);
        const padX = parseFloat(lightboxStyle.paddingLeft) + parseFloat(lightboxStyle.paddingRight);
        const padY = parseFloat(lightboxStyle.paddingTop) + parseFloat(lightboxStyle.paddingBottom);
        const aspect = srcRect.width / srcRect.height;
        const maxW = lightbox.clientWidth - padX;
        const maxH = lightbox.clientHeight - padY;
        let w = maxW;
        let h = w / aspect;
        if (h > maxH) {
            h = maxH;
            w = h * aspect;
        }
        gsap.set(cloneEl, {
            width: w,
            height: h,
            display: "block",
            objectFit: srcComputed.objectFit,
            objectPosition: srcComputed.objectPosition
        });
        while(lightbox.firstChild)lightbox.removeChild(lightbox.firstChild);
        lightbox.appendChild(cloneEl);
        const dstRect = cloneEl.getBoundingClientRect();
        const flip = computeFlip(srcRect, dstRect);
        lightbox.setAttribute("aria-hidden", "false");
        document.documentElement.style.cursor = "zoom-out";
        // Lock background scroll the same way the menu does
        if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.stop();
        const tl = gsap.timeline({
            onComplete: ()=>{
                isAnimating = false;
                isOpen = true;
                attachCloseListeners();
            }
        });
        tl.to(lightbox, {
            backgroundColor: backdropColor,
            duration: 0.3,
            ease: "none"
        }, 0);
        tl.fromTo(cloneEl, {
            x: flip.tx,
            y: flip.ty,
            scaleX: flip.scaleX,
            scaleY: flip.scaleY
        }, {
            x: 0,
            y: 0,
            scaleX: 1,
            scaleY: 1,
            duration: CONFIG.openDuration,
            ease: CONFIG.openEase
        }, 0);
    }
    function close(instant = false) {
        if (!isOpen || isAnimating && !instant) return;
        isAnimating = true;
        detachCloseListeners();
        document.documentElement.style.cursor = "";
        const cleanup = ()=>{
            gsap.set(lightbox, {
                display: "none",
                clearProps: "backgroundColor"
            });
            if (cloneEl && cloneEl.parentNode) cloneEl.parentNode.removeChild(cloneEl);
            cloneEl = null;
            lightbox.setAttribute("aria-hidden", "true");
            openSourceRectDoc = null;
            isOpen = false;
            isAnimating = false;
            if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.start();
        };
        if (instant || !cloneEl) {
            gsap.killTweensOf(cloneEl);
            gsap.killTweensOf(lightbox);
            cleanup();
            return;
        }
        const dstRect = cloneEl.getBoundingClientRect();
        const startX = Number(gsap.getProperty(cloneEl, "x")) || 0;
        const startY = Number(gsap.getProperty(cloneEl, "y")) || 0;
        const startScaleX = Number(gsap.getProperty(cloneEl, "scaleX")) || 1;
        const startScaleY = Number(gsap.getProperty(cloneEl, "scaleY")) || 1;
        function currentSrcRect() {
            return {
                top: openSourceRectDoc.top - currentScrollY(),
                left: openSourceRectDoc.left,
                width: openSourceRectDoc.width,
                height: openSourceRectDoc.height
            };
        }
        let lastFlip = computeFlip(currentSrcRect(), dstRect);
        const state = {
            t: 0
        };
        gsap.to(state, {
            t: 1,
            duration: CONFIG.closeDuration,
            ease: CONFIG.closeEase,
            onUpdate: ()=>{
                lastFlip = computeFlip(currentSrcRect(), dstRect);
                const t = state.t;
                gsap.set(cloneEl, {
                    x: startX + (lastFlip.tx - startX) * t,
                    y: startY + (lastFlip.ty - startY) * t,
                    scaleX: startScaleX + (lastFlip.scaleX - startScaleX) * t,
                    scaleY: startScaleY + (lastFlip.scaleY - startScaleY) * t
                });
            },
            onComplete: cleanup
        });
        gsap.to(lightbox, {
            backgroundColor: transparent,
            duration: 0.3,
            ease: "power2.in",
            delay: CONFIG.closeDuration * 0.4
        });
    }
    function onDocumentClick(e) {
        if (!mediaQuery.matches) return; // disabled below 960px
        // Article mode: every descendant <img> in a wrapper is clickable.
        const article = e.target.closest("[data-click-zoom-article]");
        if (article) {
            const img = e.target.closest("img");
            if (img && article.contains(img)) {
                e.preventDefault();
                open(img);
                return;
            }
        }
        // Explicit trigger on the <img> or a wrapper.
        const trigger = e.target.closest("[data-click-zoom]");
        if (!trigger) return;
        const img = trigger.tagName === "IMG" ? trigger : trigger.querySelector("img");
        if (!img) return;
        e.preventDefault();
        open(img);
    }
    function onOverlayClick() {
        if (CONFIG.closeOnClick) close();
    }
    function onKeyDown(e) {
        if (CONFIG.closeOnEscape && e.key === "Escape") close();
    }
    function onWindowScroll() {
        if (!CONFIG.closeOnScroll) return;
        if (Math.abs(window.scrollY - openScrollY) < 2) return;
        close();
    }
    function onLenisScroll({ scroll: scroll }) {
        if (!CONFIG.closeOnScroll) return;
        if (Math.abs(scroll - openScrollY) < 2) return;
        close();
    }
    function attachCloseListeners() {
        lightbox.addEventListener("click", onOverlayClick);
        document.addEventListener("keydown", onKeyDown);
        // lenis.stop() blocks normal scroll input, but keep a window listener
        // as a fallback (reduced motion / no Lenis / programmatic scrolls)
        window.addEventListener("scroll", onWindowScroll, {
            passive: true
        });
        if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.on("scroll", onLenisScroll);
    }
    function detachCloseListeners() {
        lightbox.removeEventListener("click", onOverlayClick);
        document.removeEventListener("keydown", onKeyDown);
        window.removeEventListener("scroll", onWindowScroll);
        if ($7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis) $7fe0fc961c0a5700$var$lenis.off("scroll", onLenisScroll);
    }
    // If the viewport crosses the 960px breakpoint while the lightbox is
    // open, force it shut instantly rather than leaving it stuck.
    function onMediaChange(e) {
        if (!e.matches && isOpen) close(true);
    }
    if (mediaQuery.addEventListener) mediaQuery.addEventListener("change", onMediaChange);
    else // Safari <14 fallback
    mediaQuery.addListener(onMediaChange);
    // Delegated on document so it keeps working across Barba container swaps
    // without needing re-init per page.
    document.addEventListener("click", onDocumentClick);
    // Expose an instant-close for Barba's afterLeave hook so the lightbox
    // never survives a page transition mid-animation.
    $7fe0fc961c0a5700$var$clickZoomForceClose = ()=>close(true);
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupClickToZoom() {
    $7fe0fc961c0a5700$var$clickZoomForceClose?.();
}
// ---------------------------
// Word Stagger Skew (Effect 029)
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect029(container = document) {
    const roots = container.querySelectorAll('.mwg_effect029');
    if (!roots.length) return;
    roots.forEach((root)=>{
        // Avoid double-init if this ever runs twice on the same root
        if (root._effect029Tweens) return;
        const paragraph = root.querySelector('.paragraph');
        if (!paragraph) return;
        $7fe0fc961c0a5700$var$wrapWordsInSpan(paragraph);
        const words = paragraph.querySelectorAll('span');
        words.forEach((word)=>{
            word.classList.add('word' + Math.floor(Math.random() * 4));
        });
        const offsets = {
            word1: '-0.8em',
            word2: '1.6em',
            word3: '-2.4em'
        };
        const tweens = [];
        Object.entries(offsets).forEach(([cls, x])=>{
            root.querySelectorAll(`.${cls}`).forEach((el)=>{
                tweens.push(gsap.to(el, {
                    x: x,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 80%',
                        end: 'bottom 60%',
                        scrub: 0.2
                    }
                }));
            });
        });
        root._effect029Tweens = tweens;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect029(container) {
    if (!container) return;
    container.querySelectorAll('.mwg_effect029').forEach((root)=>{
        if (root._effect029Tweens) {
            root._effect029Tweens.forEach((tween)=>{
                tween.scrollTrigger?.kill();
                tween.kill();
            });
            root._effect029Tweens = null;
        }
    });
}
// UTIL METHOD
function $7fe0fc961c0a5700$var$wrapWordsInSpan(element) {
    const text = element.textContent;
    element.innerHTML = text.split(' ').map((word)=>`<span>${word}</span>`).join(' ');
}
// ---------------------------
// Data-Speed Parallax (Locomotive-style, viewport-relative)
// ---------------------------
let $7fe0fc961c0a5700$var$parallaxElements = [];
let $7fe0fc961c0a5700$var$parallaxTickerAdded = false;
let $7fe0fc961c0a5700$var$parallaxResizeBound = false;
let $7fe0fc961c0a5700$var$parallaxResizeHandler = null;
// Amount of pixel travel per full unit of `data-speed`.
// Tune this — higher = more dramatic parallax.
const $7fe0fc961c0a5700$var$PARALLAX_STRENGTH = 200;
const $7fe0fc961c0a5700$var$parallaxMM = gsap.matchMedia();
function $7fe0fc961c0a5700$var$measureParallaxBase(el) {
    const prevY = gsap.getProperty(el, "y");
    gsap.set(el, {
        y: 0
    });
    const rect = el.getBoundingClientRect();
    const scrollY = $7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis ? $7fe0fc961c0a5700$var$lenis.scroll : window.scrollY;
    el._parallaxBaseTop = rect.top + scrollY;
    el._parallaxHeight = rect.height;
    gsap.set(el, {
        y: prevY
    });
}
function $7fe0fc961c0a5700$var$initParallax(container = document) {
    if ($7fe0fc961c0a5700$var$reducedMotion) return;
    $7fe0fc961c0a5700$var$parallaxMM.add("(min-width: 769px)", ()=>{
        $7fe0fc961c0a5700$var$parallaxElements = Array.from(container.querySelectorAll('[data-speed]'));
        $7fe0fc961c0a5700$var$parallaxElements.forEach((el)=>{
            el._parallaxSpeed = parseFloat(el.getAttribute('data-speed')) || 0;
            $7fe0fc961c0a5700$var$measureParallaxBase(el);
        });
        if (!$7fe0fc961c0a5700$var$parallaxTickerAdded) {
            gsap.ticker.add($7fe0fc961c0a5700$var$updateParallax);
            $7fe0fc961c0a5700$var$parallaxTickerAdded = true;
        }
        if (!$7fe0fc961c0a5700$var$parallaxResizeBound) {
            $7fe0fc961c0a5700$var$parallaxResizeHandler = $7fe0fc961c0a5700$var$debounceOnWidthChange($7fe0fc961c0a5700$var$remeasureParallax, 200);
            window.addEventListener('resize', $7fe0fc961c0a5700$var$parallaxResizeHandler);
            $7fe0fc961c0a5700$var$parallaxResizeBound = true;
        }
        // gsap.matchMedia cleanup: runs automatically when the query
        // stops matching (or on parallaxMM.revert()).
        return ()=>{
            $7fe0fc961c0a5700$var$cleanupParallax();
        };
    });
}
function $7fe0fc961c0a5700$var$remeasureParallax() {
    $7fe0fc961c0a5700$var$parallaxElements.forEach($7fe0fc961c0a5700$var$measureParallaxBase);
}
function $7fe0fc961c0a5700$var$updateParallax() {
    if (!$7fe0fc961c0a5700$var$parallaxElements.length) return;
    const scrollY = $7fe0fc961c0a5700$var$hasLenis && $7fe0fc961c0a5700$var$lenis ? $7fe0fc961c0a5700$var$lenis.scroll : window.scrollY;
    const winH = window.innerHeight;
    $7fe0fc961c0a5700$var$parallaxElements.forEach((el)=>{
        const top = el._parallaxBaseTop - scrollY;
        const height = el._parallaxHeight;
        let progress = (winH - top) / (winH + height);
        progress = Math.min(Math.max(progress, 0), 1);
        if (progress === el._parallaxLastProgress) return;
        el._parallaxLastProgress = progress;
        const offset = (progress - 0.5) * 2;
        const y = offset * $7fe0fc961c0a5700$var$PARALLAX_STRENGTH * el._parallaxSpeed;
        gsap.set(el, {
            y: y
        });
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupParallax() {
    if ($7fe0fc961c0a5700$var$parallaxTickerAdded) {
        gsap.ticker.remove($7fe0fc961c0a5700$var$updateParallax);
        $7fe0fc961c0a5700$var$parallaxTickerAdded = false;
    }
    if ($7fe0fc961c0a5700$var$parallaxResizeBound && $7fe0fc961c0a5700$var$parallaxResizeHandler) {
        window.removeEventListener('resize', $7fe0fc961c0a5700$var$parallaxResizeHandler);
        $7fe0fc961c0a5700$var$parallaxResizeBound = false;
        $7fe0fc961c0a5700$var$parallaxResizeHandler = null;
    }
    // reset any y offsets applied to elements so layout doesn't stay shifted below 769px
    $7fe0fc961c0a5700$var$parallaxElements.forEach((el)=>gsap.set(el, {
            y: 0
        }));
    $7fe0fc961c0a5700$var$parallaxElements = [];
}
// ---------------------------
// Corner 3 SVG Reveal
// ---------------------------
/* function initCorner3Reveal(container = document) {
  const svgs = container.querySelectorAll('.corner3');
  if (!svgs.length) return;

  svgs.forEach((svg) => {
    if (svg._corner1TL) return;

    const corners = svg.querySelectorAll('.corner');
    if (!corners.length) return;

    corners.forEach((corner) => {
      gsap.set(corner, {
        rotation: () => gsap.utils.random([-90, 90]),
        transformOrigin: "50% 50%",
        transformBox: "view-box" // Uses each path's individual bounding box to calculate center
      });
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: svg,
        start: "top 60%",
        toggleActions: "play none none none"
      }
    });

    tl.to(corners, {
      rotation: 0,
      duration: 1,
      stagger: 0.05,
      ease: "expo.out"
    });

    svg._corner1TL = tl;
  });
}


// DO NOT REMOVE THIS
function cleanupCorner1Reveal(container) {
  if (!container) return;

  container.querySelectorAll('.corner3').forEach((svg) => {
    if (svg._corner1TL) {
      svg._corner1TL.scrollTrigger?.kill();
      svg._corner1TL.kill();
      svg._corner1TL = null;
    }
  });
}
 */ function $7fe0fc961c0a5700$var$initCorner3Reveal(container = document) {
    const svgs = container.querySelectorAll('.corner3');
    if (!svgs.length) return;
    svgs.forEach((svg)=>{
        if (svg._corner1TL) return;
        const corners = svg.querySelectorAll('.corner');
        if (!corners.length) return;
        corners.forEach((corner)=>{
            gsap.set(corner, {
                opacity: ()=>gsap.utils.random([
                        0,
                        1
                    ])
            });
        });
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: svg,
                start: "top 60%",
                toggleActions: "play none none none"
            }
        });
        tl.to(corners, {
            opacity: 1,
            duration: 1,
            stagger: 0.05,
            ease: "expo.out"
        });
        svg._corner1TL = tl;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupCorner3Reveal(container) {
    if (!container) return;
    container.querySelectorAll('.corner3').forEach((svg)=>{
        if (svg._corner1TL) {
            svg._corner1TL.scrollTrigger?.kill();
            svg._corner1TL.kill();
            svg._corner1TL = null;
        }
    });
}
// ---------------------------
// Pin Bottom Div Effect
// ---------------------------
function $7fe0fc961c0a5700$var$initPinBottom(container = document) {
    const elements = container.querySelectorAll(".d-ct-pin-bottom");
    if (!elements.length) return;
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    elements.forEach((element)=>{
        // Avoid duplicated triggers on re-runs
        if (element._pinST) {
            element._pinST.kill();
            element._pinST = null;
        }
        const st = ScrollTrigger.create({
            trigger: element,
            start: "bottom bottom",
            end: "+=100%",
            pin: true,
            pinSpacing: false,
            ...isDesktop && {
                pinType: 'transform'
            },
            anticipatePin: 1
        });
        element._pinST = st;
    });
    if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
}
// DO NOT REMOVE THIS (Cleanup for Barba lifecycle)
function $7fe0fc961c0a5700$var$cleanupPinBottom(container) {
    if (!container) return;
    const elements = container.querySelectorAll(".d-ct-pin-bottom");
    elements.forEach((element)=>{
        if (element._pinST) {
            element._pinST.kill();
            element._pinST = null;
        }
    });
}
// ---------------------------
// Rotor Rotation Effect
// ---------------------------
function $7fe0fc961c0a5700$var$initRotorRotation(container = document) {
    const elements = container.querySelectorAll('.d-ct-rotor');
    if (!elements.length) return;
    elements.forEach((element)=>{
        // Kill existing instances on re-runs
        if (element._rotorTL) {
            element._rotorTL.scrollTrigger?.kill();
            element._rotorTL.kill();
            element._rotorTL = null;
        }
        // Set origin to top-left corner and initial rotation to 12deg
        gsap.set(element, {
            //rotation: "7deg",
            xPercent: "7",
            force3D: true,
            willChange: "transform"
        });
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: "top 100%",
                end: "top 75%",
                scrub: true
            }
        });
        tl.to(element, {
            //rotation: "0deg",
            xPercent: "0",
            force3D: true,
            ease: "none"
        });
        element._rotorTL = tl;
    });
    if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
}
function $7fe0fc961c0a5700$var$cleanupRotorRotation(container) {
    if (!container) return;
    container.querySelectorAll('.d-ct-rotor').forEach((el)=>{
        if (el._rotorTL) {
            el._rotorTL.scrollTrigger?.kill();
            el._rotorTL.kill();
            el._rotorTL = null;
        }
    });
}
// ---------------------------
// Border Box H Scale/Rotate Reveal
// ---------------------------
function $7fe0fc961c0a5700$var$initBorderBoxHReveal(container = document) {
    const elements = container.querySelectorAll('.d-ct-border-box-h');
    if (!elements.length) return;
    const triggers = ScrollTrigger.batch(elements, {
        start: "top 55%",
        once: true,
        onEnter: (batch)=>{
            gsap.to(batch, {
                scaleX: ()=>gsap.utils.random(1.04, 1.07),
                rotation: ()=>gsap.utils.random(-3, 3),
                backgroundColor: "var(--color-white)",
                duration: 0.5,
                stagger: 0.1,
                ease: "jump",
                overwrite: true
            });
        }
    });
    container._borderBoxHTriggers = (container._borderBoxHTriggers || []).concat(triggers);
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupBorderBoxHReveal(container) {
    if (!container) return;
    if (container._borderBoxHTriggers) {
        container._borderBoxHTriggers.forEach((t)=>t.kill());
        container._borderBoxHTriggers = null;
    }
    container.querySelectorAll?.('.d-ct-border-box-h').forEach((el)=>gsap.killTweensOf(el));
}
// ---------------------------
// Split Letters Hover (Effect 086)
// Runs once from initOnceFunctions
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect086() {
    const ROOT = '.mwg_effect086';
    // Hover-only effect: skip on touch devices and for reduced motion
    if ($7fe0fc961c0a5700$var$reducedMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.fonts.ready.then(()=>{
        function wrapLettersInSpan(element) {
            element.innerHTML = element.textContent.split('').map((char)=>`<span class="letter">${char === ' ' ? '&nbsp;' : char}</span>`).join('');
            element.dataset.wrapped = 'true';
        }
        function onLetterEnter(letter, clientX) {
            const parent = letter.closest('.text');
            if (parent.classList.contains('hovered')) {
                if (parent.classList.contains('outro')) {
                    parent.classList.remove('outro');
                    parent.tl?.play();
                }
                return;
            }
            parent.classList.add('hovered');
            const siblings = Array.from(parent.querySelectorAll('.letter'));
            const index = siblings.indexOf(letter);
            const rect = letter.getBoundingClientRect();
            const isPastMidpoint = clientX > rect.left + rect.width / 2;
            const splitIndex = isPastMidpoint ? index : index - 1;
            const leftLetters = siblings.slice(0, splitIndex + 1);
            const rightLetters = siblings.slice(splitIndex + 1);
            const media = parent.parentElement.querySelector('.media');
            if (!media) {
                parent.classList.remove('hovered');
                return;
            }
            const lastLeftLetter = leftLetters[leftLetters.length - 1];
            const leftDistance = lastLeftLetter ? lastLeftLetter.getBoundingClientRect().right - parent.getBoundingClientRect().left : 0;
            const tl = gsap.timeline({
                onReverseComplete: ()=>parent.classList.remove('hovered', 'outro')
            });
            parent.tl = tl;
            tl.fromTo(media, {
                x: leftDistance,
                xPercent: -50
            }, {
                clipPath: 'inset(0% 0% round 50% 0% 50% 50%)',
                duration: 0.4,
                ease: 'expo.inOut'
            }, 0);
            if (leftLetters.length) tl.to(leftLetters, {
                x: -0.0275 * window.innerWidth,
                duration: 0.4,
                ease: 'expo.inOut'
            }, 0);
            if (rightLetters.length) tl.to(rightLetters, {
                x: 0.0275 * window.innerWidth,
                duration: 0.4,
                ease: 'expo.inOut'
            }, 0);
        }
        function onTextLeave(text) {
            if (text.classList.contains('outro') || !text.classList.contains('hovered')) return;
            text.classList.add('outro');
            text.tl?.reverse();
        }
        document.addEventListener('mouseover', (e)=>{
            const text = e.target.closest?.(`${ROOT} .text`);
            if (!text) return;
            let letter = e.target.closest('.letter');
            // Lazy wrap on first touch (fresh DOM after every Barba swap)
            if (!text.dataset.wrapped) {
                wrapLettersInSpan(text);
                letter = document.elementFromPoint(e.clientX, e.clientY)?.closest('.letter');
            }
            if (!letter) return;
            onLetterEnter(letter, e.clientX);
        });
        // mouseout + relatedTarget check = delegated equivalent of mouseleave
        document.addEventListener('mouseout', (e)=>{
            const text = e.target.closest?.(`${ROOT} .text`);
            if (!text || text.contains(e.relatedTarget)) return;
            onTextLeave(text);
        });
    });
}
// ---------------------------
// Particle Triangle (pointer repel)
// ---------------------------
function $7fe0fc961c0a5700$var$initParticleTriangle(container = document) {
    container.querySelectorAll('.d-ct-particles').forEach((wrap)=>{
        if (wrap._destroyParticles) return; // avoid double-init
        const canvas = wrap.querySelector('canvas');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const PUSH = 1.6;
        const SPRING = 0.06;
        const FRICTION = 0.86;
        const N = 24;
        const GAP_RATIO = 2;
        const OVERFILL = 0.1; // extra canvas on each side, as a fraction of wrapper width
        let W = 0, H = 0, CW = 0, CH = 0, PAD = 0, dpr = 1, RADIUS = 110;
        let particles = [];
        let rgb = '18, 18, 18';
        let inView = false;
        let lastWidth = 0;
        const pointer = {
            x: -9999,
            y: -9999
        }; // client coords
        const readColor = ()=>{
            const v = getComputedStyle(document.documentElement).getPropertyValue('--dot').trim();
            rgb = v || '18, 18, 18';
        };
        readColor();
        function build() {
            dpr = Math.min(window.devicePixelRatio || 1, 2);
            W = wrap.clientWidth;
            H = W;
            if (!W) return;
            lastWidth = W;
            RADIUS = W * 0.18;
            // canvas is larger than the wrapper and centred on it
            PAD = Math.round(W * OVERFILL);
            CW = W + PAD * 2;
            CH = H + PAD * 2;
            canvas.width = CW * dpr;
            canvas.height = CH * dpr;
            // shift the origin so (0,0) is still the wrapper's top-left corner
            ctx.setTransform(dpr, 0, 0, dpr, PAD * dpr, PAD * dpr);
            // triangle fills the wrapper exactly, same as before
            const size = Math.min(W, H);
            const cx = W / 2, cy = H / 2;
            const Bx = cx - size / 2;
            const Ay = cy - size / 2;
            const s = size / (N + (N - 1) * GAP_RATIO);
            const pitch = s * (1 + GAP_RATIO);
            particles = [];
            for(let row = 0; row < N; row++)for(let col = 0; col < N; col++){
                if (col + row < N - 1) continue;
                const hx = Bx + col * pitch + s / 2;
                const hy = Ay + row * pitch + s / 2;
                particles.push({
                    hx: hx,
                    hy: hy,
                    x: hx,
                    y: hy,
                    vx: 0,
                    vy: 0,
                    r: s / 2
                });
            }
            // Paint the finished triangle right away (no simulation step)
            draw(0, 0, false);
        }
        function draw(mx, my, simulate = true, dt = 1) {
            ctx.clearRect(-PAD, -PAD, CW, CH);
            const R2 = RADIUS * RADIUS;
            const fr = Math.pow(FRICTION, dt);
            for(let i = 0; i < particles.length; i++){
                const p = particles[i];
                if (simulate) {
                    const dx = p.x - mx, dy = p.y - my;
                    const d2 = dx * dx + dy * dy;
                    if (d2 < R2) {
                        const d = Math.sqrt(d2) || 1;
                        const f = (1 - d / RADIUS) * PUSH;
                        p.vx += dx / d * f * 4 * dt;
                        p.vy += dy / d * f * 4 * dt;
                    }
                    p.vx += (p.hx - p.x) * SPRING * dt;
                    p.vy += (p.hy - p.y) * SPRING * dt;
                    p.vx *= fr;
                    p.vy *= fr;
                    p.x += p.vx * dt;
                    p.y += p.vy * dt;
                }
                const away = Math.min(1, Math.hypot(p.x - p.hx, p.y - p.hy) / 60);
                ctx.fillStyle = `rgba(${rgb}, ${1 - away * 0.6})`;
                ctx.beginPath();
                ctx.moveTo(p.x - p.r, p.y + p.r); // bottom-left, 45°
                ctx.lineTo(p.x + p.r, p.y + p.r); // bottom-right, 90°
                ctx.lineTo(p.x + p.r, p.y - p.r); // top-right, 45°
                ctx.closePath();
                ctx.fill();
            }
        }
        const tick = (time, deltaTime)=>{
            if (!inView || !W) return;
            const dt = Math.min(deltaTime / 16.667, 2.5);
            // measure against the wrapper (not the padded canvas),
            // recalculated every frame so Lenis scroll stays correct
            const rect = wrap.getBoundingClientRect();
            const mx = (pointer.x - rect.left) * (W / rect.width);
            const my = (pointer.y - rect.top) * (H / rect.height);
            draw(mx, my, true, dt);
        };
        const onMove = (e)=>{
            const t = e.touches ? e.touches[0] : e;
            if (!t) return;
            pointer.x = t.clientX;
            pointer.y = t.clientY;
        };
        const onLeave = ()=>{
            pointer.x = pointer.y = -9999;
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('touchstart', onMove, {
            passive: true
        });
        window.addEventListener('touchmove', onMove, {
            passive: true
        });
        window.addEventListener('touchend', onLeave);
        document.documentElement.addEventListener('mouseleave', onLeave);
        // Only rebuild on WIDTH change (mobile address bar fires height-only resizes)
        const ro = new ResizeObserver(()=>{
            if (wrap.clientWidth !== lastWidth) build();
        });
        ro.observe(wrap);
        // Only simulate while visible
        const io = new IntersectionObserver(([entry])=>{
            inView = entry.isIntersecting;
        }, {
            rootMargin: '100px'
        });
        io.observe(wrap);
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const onScheme = ()=>{
            readColor();
            draw(0, 0, false);
        };
        mq.addEventListener?.('change', onScheme);
        build();
        if (!$7fe0fc961c0a5700$var$reducedMotion) gsap.ticker.add(tick);
        wrap._destroyParticles = ()=>{
            gsap.ticker.remove(tick);
            ro.disconnect();
            io.disconnect();
            mq.removeEventListener?.('change', onScheme);
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('touchstart', onMove);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onLeave);
            document.documentElement.removeEventListener('mouseleave', onLeave);
            particles = [];
            wrap._destroyParticles = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupParticleTriangle(container) {
    if (!container) return;
    container.querySelectorAll('.d-ct-particles').forEach((wrap)=>{
        wrap._destroyParticles?.();
    });
}
// ---------------------------
// 3D Carousel Wheel (Effect 106)
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect106(container = document) {
    const roots = container.querySelectorAll('.mwg_effect106');
    roots.forEach((root)=>{
        // Avoid double-init if this ever runs twice on the same root
        if (root._destroyEffect106) return;
        const mediasContainer = root.querySelector('.medias');
        const medias = root.querySelectorAll('.media');
        if (!mediasContainer || !medias.length) return;
        const baseAngles = Array.from({
            length: medias.length
        }, (_, i)=>i / medias.length * Math.PI * 2);
        const DESKTOP_MEDIA_VW = 12;
        const MOBILE_MEDIA_VW = 30;
        // Where the "virtual mouse" sits at start: 0-1 across the scene
        // x: 0 = left, 1 = right | y: 0 = top, 1 = bottom
        const DEFAULT_POINTER = {
            x: 0.75,
            y: 0.25
        }; // upper right quadrant
        let mediaVw = DESKTOP_MEDIA_VW;
        let layout = null;
        function getLayout() {
            const w = window.innerWidth;
            const h = window.innerHeight;
            const scale = mediaVw / DESKTOP_MEDIA_VW;
            return {
                w: w,
                h: h,
                scale: scale,
                radiusDivisor: 3.5 / scale,
                translateZ: -26 * scale
            };
        }
        // Single source of truth for the pointer -> tilt mapping
        function tiltFor(fx, fy) {
            return {
                rotateY: fx * 50 - 25,
                rotateX: fy * 40 - 20 + 90,
                rotateZ: -fx * 10 + 5
            };
        }
        const transform = {
            ...tiltFor(DEFAULT_POINTER.x, DEFAULT_POINTER.y),
            translateX: 0,
            translateY: 0
        };
        const autoOffset = {
            value: 0
        };
        function renderTilt() {
            const { translateX: translateX, translateY: translateY, rotateX: rotateX, rotateY: rotateY, rotateZ: rotateZ } = transform;
            const { translateZ: translateZ } = layout;
            mediasContainer.style.transform = `translate3d(${translateX}vw, ${translateY}vw, ${translateZ}vw) rotateX(${rotateX}deg) rotateY(${rotateY}deg) rotateZ(${rotateZ}deg)`;
            medias.forEach((el)=>{
                gsap.set(el, {
                    rotationX: -rotateX,
                    rotationY: -rotateY,
                    rotation: -rotateZ
                });
            });
        }
        function updateScene() {
            const { w: w, radiusDivisor: radiusDivisor } = layout;
            const radius = w / radiusDivisor;
            medias.forEach((el, i)=>{
                const angle = autoOffset.value + baseAngles[i];
                gsap.set(el, {
                    x: Math.sin(angle) * radius,
                    y: Math.cos(angle) * radius
                });
            });
        }
        function relayout() {
            layout = getLayout();
            renderTilt();
            updateScene();
        }
        const tilt = {
            duration: 0.8,
            ease: "power3"
        };
        const setRotateX = gsap.quickTo(transform, "rotateX", tilt);
        const setRotateY = gsap.quickTo(transform, "rotateY", tilt);
        const setRotateZ = gsap.quickTo(transform, "rotateZ", {
            ...tilt,
            onUpdate: renderTilt
        });
        function applyTilt(clientX, clientY) {
            const { w: w, h: h } = layout;
            const t = tiltFor(clientX / w, clientY / h);
            setRotateY(t.rotateY);
            setRotateX(t.rotateX);
            setRotateZ(t.rotateZ);
        }
        function handleMouseMove(e) {
            applyTilt(e.clientX, e.clientY);
        }
        function handleTouchMove(e) {
            if (!e.touches?.[0]) return;
            applyTilt(e.touches[0].clientX, e.touches[0].clientY);
        }
        const autoTween = gsap.to(autoOffset, {
            value: Math.PI * 2,
            duration: 18,
            repeat: -1,
            ease: "none",
            onUpdate: updateScene
        });
        // matchMedia: set mediaVw first, relayout only once layout exists
        // (so a breakpoint change after init updates the scene too)
        const mm = gsap.matchMedia();
        mm.add("(max-width: 768px)", ()=>{
            mediaVw = MOBILE_MEDIA_VW;
            if (layout) relayout();
        });
        mm.add("(min-width: 769px)", ()=>{
            mediaVw = DESKTOP_MEDIA_VW;
            if (layout) relayout();
        });
        root.style.perspective = "100vw"; // fixed now that the scroll effect is gone
        relayout();
        // Keep w/h fresh on width changes (uses your existing helper)
        const onResize = $7fe0fc961c0a5700$var$debounceOnWidthChange(relayout, 200);
        window.addEventListener("resize", onResize);
        root.addEventListener("mousemove", handleMouseMove);
        root.addEventListener("touchstart", handleTouchMove, {
            passive: true
        });
        root.addEventListener("touchmove", handleTouchMove, {
            passive: true
        });
        // Store cleanup so Barba can tear this down on page leave
        root._destroyEffect106 = ()=>{
            root.removeEventListener("mousemove", handleMouseMove);
            root.removeEventListener("touchstart", handleTouchMove);
            root.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("resize", onResize);
            mm.revert();
            autoTween.kill();
            gsap.killTweensOf([
                transform,
                autoOffset
            ]); // also kills the quickTo tweens
            gsap.killTweensOf(medias);
            gsap.set(medias, {
                clearProps: "all"
            });
            root.style.perspective = "";
            mediasContainer.style.transform = "";
            root._destroyEffect106 = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect106(container) {
    if (!container) return;
    container.querySelectorAll('.mwg_effect106').forEach((root)=>{
        root._destroyEffect106?.();
    });
}
// ---------------------------
// Project Case Meta Pin
// ---------------------------
function $7fe0fc961c0a5700$var$initProjectCase(container = document) {
    const cases = container.querySelectorAll('.d-project-case');
    if (!cases.length) return;
    // Re-init guard (container is the Barba container or document)
    if (container._projectCaseMM) return;
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const DURATION = 0.5; // seconds, bump up or down to taste
    const EASE = 'power3.out'; // used in both directions
    const mm = gsap.matchMedia();
    mm.add('(min-width: 769px)', ()=>{
        cases.forEach((caseEl)=>{
            const meta = caseEl.querySelector('.d-project-meta');
            const title = caseEl.querySelector('.d-project-meta-title');
            const year = caseEl.querySelector('.d-project-meta-year');
            const effect = caseEl.querySelector('.mwg_effect036');
            if (!meta || !title || !year || !effect) return;
            const split = ()=>{
                gsap.to(title, {
                    xPercent: -100,
                    duration: DURATION,
                    ease: EASE,
                    overwrite: 'auto'
                });
                gsap.to(year, {
                    xPercent: 100,
                    duration: DURATION,
                    ease: EASE,
                    overwrite: 'auto'
                });
            };
            const join = ()=>{
                gsap.to([
                    title,
                    year
                ], {
                    xPercent: 0,
                    duration: DURATION,
                    ease: EASE,
                    overwrite: 'auto'
                });
            };
            ScrollTrigger.create({
                trigger: meta,
                start: 'top 50%',
                endTrigger: effect,
                end: 'bottom 50%',
                pin: meta,
                pinSpacing: false,
                ...isDesktop && {
                    pinType: 'transform'
                },
                anticipatePin: 1,
                onToggle: (self)=>self.isActive ? split() : join()
            });
        });
        // Optional: runs automatically when the query stops matching
        return ()=>{
            gsap.set(container.querySelectorAll('.d-project-meta-title, .d-project-meta-year'), {
                clearProps: 'transform'
            });
        };
    });
    container._projectCaseMM = mm;
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupProjectCase(container) {
    if (!container) return;
    if (container._projectCaseMM) {
        container._projectCaseMM.revert(); // kills the triggers, pins, tweens and runs the return fn
        container._projectCaseMM = null;
    }
}
// ---------------------------
// End Project Case Meta Pin
// ---------------------------
// ---------------------------
// Project Block Desc Pin
// ---------------------------
function $7fe0fc961c0a5700$var$initProjectBlock(container = document) {
    const blocks = container.querySelectorAll('.d-project-block');
    if (!blocks.length) return;
    // Re-init guard (container is the Barba container or document)
    if (container._projectBlockMM) return;
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    // Pin starts when the top of .d-project-screens reaches this point of the viewport.
    // Use '17%' for 17% of viewport height, or '17px' for pixels.
    const PIN_START = '12%';
    const mm = gsap.matchMedia();
    mm.add('(min-width: 769px)', ()=>{
        blocks.forEach((block)=>{
            const desc = block.querySelector('.d-project-desc');
            const screens = block.querySelector('.d-project-screens');
            const isFirefox = navigator.userAgent.includes('Firefox');
            if (!desc || !screens) return;
            ScrollTrigger.create({
                trigger: screens,
                start: `top ${PIN_START}`,
                // Unpin when the bottom of desc meets the bottom of screens.
                // desc stays fixed in the viewport while pinned, so the scroll distance is:
                // screensHeight - (descHeight + descOffsetBelowScreensTop)
                end: ()=>{
                    const delta = desc.getBoundingClientRect().top - screens.getBoundingClientRect().top;
                    const distance = screens.offsetHeight - desc.offsetHeight - delta;
                    return `+=${Math.max(0, distance)}`;
                },
                pin: desc,
                pinSpacing: true,
                invalidateOnRefresh: true,
                ...isDesktop && !isFirefox && {
                    pinType: 'transform'
                }
            });
        });
        // Runs automatically when the query stops matching
        return ()=>{
            gsap.set(container.querySelectorAll('.d-project-desc'), {
                clearProps: 'transform'
            });
        };
    });
    container._projectBlockMM = mm;
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupProjectBlock(container) {
    if (!container) return;
    if (container._projectBlockMM) {
        container._projectBlockMM.revert(); // kills the triggers, pins and runs the return fn
        container._projectBlockMM = null;
    }
}
// ---------------------------
// End Project Block Desc Pin
// ---------------------------
// ---------------------------
// Particle Grid 35 x 5 (liquid pointer-following shape, bottom-right anchored)
// Lives INSIDE the Barba container: init in beforeEnter, cleanup in afterLeave
// ---------------------------
function $7fe0fc961c0a5700$var$initParticleFollow(root = document) {
    root.querySelectorAll('.d-ct-particles-follow').forEach((wrap)=>{
        if (wrap._destroyParticlesFollow) return; // avoid double-init
        let canvas = wrap.querySelector('canvas');
        if (!canvas) {
            canvas = document.createElement('canvas');
            wrap.appendChild(canvas);
        }
        const ctx = canvas.getContext('2d');
        const COLS = 35;
        const ROWS = 5;
        const REST = 0.17; // default particle size = 50% of the cell
        const FULL = 1.0; // the 5 shape particles = 100% of the cell
        const BIG = FULL / REST; // 2 (scale relative to the default size)
        const NEAR = 1.5; // neighbours next to the shape swell to 75% of the cell
        const SPREAD = 3; // columns the swell fades out over (each side)
        const FOLLOW = 0.07; // shape glide toward the pointer (lower = smoother/slower)
        const EASE = 0.1; // size easing per particle (lower = smoother/slower)
        // shape as offsets from the centre column, rows 0-4
        //  xoo
        //  oxo
        //  oox
        //  oxo
        //  xoo
        const SHAPE = [
            [
                -1,
                0
            ],
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                0,
                3
            ],
            [
                -1,
                4
            ]
        ];
        let W = 0, H = 0, dpr = 1;
        let s = 0, pitch = 0;
        let particles = [];
        let rgb = '18, 18, 18';
        let inView = false;
        let lastWidth = 0;
        let cx = Math.floor(COLS / 2); // smoothed centre column (float)
        let targetCx = cx; // always a whole column
        const pointer = {
            x: -9999,
            y: -9999
        };
        const readColor = ()=>{
            const v = getComputedStyle(document.documentElement).getPropertyValue('--dot').trim();
            rgb = v || '18, 18, 18';
        };
        readColor();
        const clampCol = (c)=>Math.max(1, Math.min(COLS - 2, c));
        const smooth = (t)=>t * t * (3 - 2 * t);
        function computeTargets() {
            // 1) continuous shape weights: a shape cell sitting between two columns
            //    shares its weight between them, so growth/shrink is gradual
            const w = new Float32Array(particles.length);
            for(let k = 0; k < SHAPE.length; k++){
                const dc = SHAPE[k][0], dr = SHAPE[k][1];
                const pos = cx + dc;
                const c0 = Math.floor(pos);
                const f = pos - c0;
                const a = dr * COLS + c0;
                if (c0 >= 0 && c0 < COLS) w[a] = Math.max(w[a], 1 - f);
                if (c0 + 1 >= 0 && c0 + 1 < COLS) w[a + 1] = Math.max(w[a + 1], f);
            }
            // 2) neighbour swell by distance + shape weight, whichever is larger
            for(let i = 0; i < particles.length; i++){
                const p = particles[i];
                const d = Math.abs(p.col - cx);
                const t = Math.max(0, Math.min(1, 1 - (d - 1.5) / SPREAD));
                const swell = 1 + (NEAR - 1) * smooth(t);
                const shape = 1 + (BIG - 1) * smooth(w[i]);
                p.target = Math.max(swell, shape);
            }
        }
        function build() {
            dpr = Math.min(window.devicePixelRatio || 1, 2);
            W = wrap.clientWidth;
            if (!W) return;
            lastWidth = W;
            pitch = W / COLS; // cell size
            s = pitch * REST; // default particle = 50% of the cell
            H = Math.round(pitch * ROWS);
            canvas.width = W * dpr;
            canvas.height = H * dpr;
            canvas.style.width = W + 'px';
            canvas.style.height = H + 'px';
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            particles = [];
            for(let row = 0; row < ROWS; row++)for(let col = 0; col < COLS; col++)particles.push({
                col: col,
                bx: (col + 1) * pitch,
                by: (row + 1) * pitch,
                scale: 1,
                target: 1
            });
            computeTargets();
            particles.forEach((p)=>{
                p.scale = p.target;
            });
            draw();
        }
        function draw() {
            ctx.clearRect(0, 0, W, H);
            ctx.fillStyle = `rgb(${rgb})`;
            ctx.beginPath();
            for(let i = 0; i < particles.length; i++){
                const p = particles[i];
                const L = s * p.scale;
                ctx.moveTo(p.bx - L, p.by); // bottom-left
                ctx.lineTo(p.bx, p.by); // bottom-right (fixed corner)
                ctx.lineTo(p.bx, p.by - L); // top-right
                ctx.closePath();
            }
            ctx.fill();
        }
        const tick = (time, deltaTime)=>{
            if (!inView || !W) return;
            const dt = Math.min(deltaTime / 16.667, 2.5);
            const rect = wrap.getBoundingClientRect();
            if (pointer.x >= rect.left && pointer.x <= rect.right && pointer.y >= rect.top && pointer.y <= rect.bottom) {
                const mx = (pointer.x - rect.left) * (W / rect.width);
                targetCx = clampCol(Math.round(mx / pitch - 0.5)); // whole column under the pointer
            }
            const kf = 1 - Math.pow(1 - FOLLOW, dt);
            const dx = targetCx - cx;
            const moving = Math.abs(dx) > 0.001;
            cx = moving ? cx + dx * kf : targetCx;
            computeTargets();
            const ke = 1 - Math.pow(1 - EASE, dt);
            let busy = moving;
            for(let i = 0; i < particles.length; i++){
                const p = particles[i];
                const diff = p.target - p.scale;
                if (Math.abs(diff) > 0.001) {
                    p.scale += diff * ke;
                    busy = true;
                } else p.scale = p.target;
            }
            if (busy) draw();
        };
        const onMove = (e)=>{
            const t = e.touches ? e.touches[0] : e;
            if (!t) return;
            pointer.x = t.clientX;
            pointer.y = t.clientY;
        };
        const onLeave = ()=>{
            pointer.x = pointer.y = -9999;
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('touchstart', onMove, {
            passive: true
        });
        window.addEventListener('touchmove', onMove, {
            passive: true
        });
        window.addEventListener('touchend', onLeave);
        document.documentElement.addEventListener('mouseleave', onLeave);
        const ro = new ResizeObserver(()=>{
            if (wrap.clientWidth !== lastWidth) build();
        });
        ro.observe(wrap);
        const io = new IntersectionObserver(([entry])=>{
            inView = entry.isIntersecting;
        }, {
            rootMargin: '100px'
        });
        io.observe(wrap);
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const onScheme = ()=>{
            readColor();
            draw();
        };
        mq.addEventListener?.('change', onScheme);
        build();
        if (!$7fe0fc961c0a5700$var$reducedMotion) gsap.ticker.add(tick);
        wrap._destroyParticlesFollow = ()=>{
            gsap.ticker.remove(tick);
            ro.disconnect();
            io.disconnect();
            mq.removeEventListener?.('change', onScheme);
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('touchstart', onMove);
            window.removeEventListener('touchmove', onMove);
            window.removeEventListener('touchend', onLeave);
            document.documentElement.removeEventListener('mouseleave', onLeave);
            particles = [];
            wrap._destroyParticlesFollow = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupParticleFollow(container) {
    if (!container) return;
    container.querySelectorAll('.d-ct-particles-follow').forEach((wrap)=>{
        wrap._destroyParticlesFollow?.();
    });
}
// ---------------------------
// WWD Pin (top-top, or bottom-bottom if taller than viewport)
// ---------------------------
function $7fe0fc961c0a5700$var$initWwdPin(container = document) {
    const elements = container.querySelectorAll('.d-d26-wwd-pin');
    const isFirefox = navigator.userAgent.includes('Firefox');
    if (!elements.length) return;
    // Re-init guard
    if (container._wwdPinMM) return;
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const mm = gsap.matchMedia();
    mm.add('(min-width: 769px)', ()=>{
        elements.forEach((el)=>{
            // Taller than the viewport? Pin at the bottom. Otherwise pin at the top.
            const isTall = ()=>el.offsetHeight > window.innerHeight;
            ScrollTrigger.create({
                trigger: el,
                start: ()=>isTall() ? 'bottom bottom' : 'top top',
                // Release when the parent's bottom meets the pinned element's bottom edge
                endTrigger: el.parentElement,
                end: ()=>{
                    const pinnedBottom = isTall() ? window.innerHeight : el.offsetHeight;
                    return `bottom ${pinnedBottom}px`;
                },
                pin: true,
                pinSpacing: false,
                invalidateOnRefresh: true,
                //...(isDesktop && { pinType: 'transform' }),
                ...isDesktop && !isFirefox && {
                    pinType: 'transform'
                }
            });
        });
        // Runs automatically when the query stops matching
        return ()=>{
            gsap.set(elements, {
                clearProps: 'transform'
            });
        };
    });
    container._wwdPinMM = mm;
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupWwdPin(container) {
    if (!container) return;
    if (container._wwdPinMM) {
        container._wwdPinMM.revert(); // kills triggers, pins and runs the return fn
        container._wwdPinMM = null;
    }
}
// ---------------------------
// Scramble Text on Scroll
// ---------------------------
function $7fe0fc961c0a5700$var$initScrambleOnScroll(container = document) {
    const targets = container.querySelectorAll('[data-scramble="scroll"]');
    if (!targets.length) return;
    // Nothing to animate for reduced motion, text just stays as-is
    if ($7fe0fc961c0a5700$var$reducedMotion) return;
    $7fe0fc961c0a5700$var$readyForScrollTriggers().then(()=>{
        targets.forEach((target)=>{
            // Avoid double-init if this ever runs twice on the same element
            if (target._scrambleTween) return;
            const isAlternative = target.hasAttribute('data-scramble-alt');
            const split = new SplitText(target, {
                type: 'words, chars',
                wordsClass: 'word',
                charsClass: 'char'
            });
            const tween = gsap.to(split.words, {
                duration: 1.4,
                stagger: 0.015,
                scrambleText: {
                    text: '{original}',
                    chars: isAlternative ? '|/\\_-' : 'upperCase',
                    speed: 0.95
                },
                scrollTrigger: {
                    trigger: target,
                    start: 'top bottom',
                    once: true
                },
                // Revert the split once finished to reduce DOM size
                onComplete: ()=>{
                    try {
                        split.revert();
                    } catch (e) {
                        console.warn(e);
                    }
                    target._scrambleSplit = null;
                }
            });
            target._scrambleSplit = split;
            target._scrambleTween = tween;
        });
        if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.refresh();
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupScrambleOnScroll(container) {
    if (!container) return;
    container.querySelectorAll('[data-scramble="scroll"]').forEach((target)=>{
        if (target._scrambleTween) {
            target._scrambleTween.scrollTrigger?.kill();
            target._scrambleTween.kill();
            target._scrambleTween = null;
        }
        if (target._scrambleSplit) {
            try {
                target._scrambleSplit.revert();
            } catch (e) {
                console.warn(e);
            }
            target._scrambleSplit = null;
        }
    });
}
// ---------------------------
// Marquee Scroll Direction (Osmo)
// Init in initAfterEnterFunctions, cleanup in barba.hooks.afterLeave
// ---------------------------
function $7fe0fc961c0a5700$var$initMarqueeScrollDirection(container = document) {
    const marquees = container.querySelectorAll('[data-marquee-scroll-direction-target]');
    if (!marquees.length) return;
    marquees.forEach((marquee)=>{
        // Avoid double-init if this ever runs twice on the same marquee
        if (marquee._destroyMarquee) return;
        const marqueeContent = marquee.querySelector('[data-marquee-collection-target]');
        const marqueeScroll = marquee.querySelector('[data-marquee-scroll-target]');
        if (!marqueeContent || !marqueeScroll) return;
        let ctx = null;
        let cancelled = false;
        const clones = [];
        // Remember original inline styles so cleanup can restore them
        const originalMarginLeft = marqueeScroll.style.marginLeft;
        const originalWidth = marqueeScroll.style.width;
        // Cleanup is registered immediately, so it also works if Barba
        // leaves the page before the layout-ready promise resolves
        marquee._destroyMarquee = ()=>{
            cancelled = true;
            ctx?.revert(); // kills tweens, timelines and ScrollTriggers created inside
            ctx = null;
            clones.forEach((clone)=>clone.remove());
            clones.length = 0;
            marqueeScroll.style.marginLeft = originalMarginLeft;
            marqueeScroll.style.width = originalWidth;
            marquee.removeAttribute('data-marquee-status');
            marquee._destroyMarquee = null;
        };
        // Reduced motion: leave the marquee static
        if ($7fe0fc961c0a5700$var$reducedMotion) return;
        // Wait for fonts + stable layout so offsetWidth is accurate
        $7fe0fc961c0a5700$var$readyForScrollTriggers().then(()=>{
            if (cancelled) return;
            const { marqueeSpeed: speed, marqueeDirection: direction, marqueeDuplicate: duplicate, marqueeScrollSpeed: scrollSpeed } = marquee.dataset;
            const marqueeSpeedAttr = parseFloat(speed) || 1;
            const marqueeDirectionAttr = direction === 'right' ? 1 : -1; // 1 = right, -1 = left
            const duplicateAmount = parseInt(duplicate || 0, 10);
            const scrollSpeedAttr = parseFloat(scrollSpeed) || 0;
            const speedMultiplier = window.innerWidth < 479 ? 0.25 : window.innerWidth < 991 ? 0.5 : 1;
            const marqueeSpeed = marqueeSpeedAttr * (marqueeContent.offsetWidth / window.innerWidth) * speedMultiplier;
            // Scroll container sizing
            marqueeScroll.style.marginLeft = `${scrollSpeedAttr * -1}%`;
            marqueeScroll.style.width = `${scrollSpeedAttr * 2 + 100}%`;
            // Duplicate marquee content (tracked so cleanup can remove it)
            if (duplicateAmount > 0) {
                const fragment = document.createDocumentFragment();
                for(let i = 0; i < duplicateAmount; i++){
                    const clone = marqueeContent.cloneNode(true);
                    clone.setAttribute('aria-hidden', 'true');
                    clones.push(clone);
                    fragment.appendChild(clone);
                }
                marqueeScroll.appendChild(fragment);
            }
            ctx = gsap.context(()=>{
                const marqueeItems = marquee.querySelectorAll('[data-marquee-collection-target]');
                const animation = gsap.to(marqueeItems, {
                    xPercent: -100,
                    repeat: -1,
                    duration: marqueeSpeed,
                    ease: 'linear'
                }).totalProgress(0.5);
                gsap.set(marqueeItems, {
                    xPercent: marqueeDirectionAttr === 1 ? 100 : -100
                });
                animation.timeScale(marqueeDirectionAttr);
                animation.play();
                marquee.setAttribute('data-marquee-status', 'normal');
                // Invert direction based on scroll direction
                ScrollTrigger.create({
                    trigger: marquee,
                    start: 'top bottom',
                    end: 'bottom top',
                    onUpdate: (self)=>{
                        const isInverted = self.direction === 1; // scrolling down
                        const currentDirection = isInverted ? -marqueeDirectionAttr : marqueeDirectionAttr;
                        animation.timeScale(currentDirection);
                        marquee.setAttribute('data-marquee-status', isInverted ? 'normal' : 'inverted');
                    }
                });
                // Extra horizontal travel tied to scroll
                const scrollStart = marqueeDirectionAttr === -1 ? scrollSpeedAttr : -scrollSpeedAttr;
                const scrollEnd = -scrollStart;
                gsap.timeline({
                    scrollTrigger: {
                        trigger: marquee,
                        start: '0% 100%',
                        end: '100% 0%',
                        scrub: 0
                    }
                }).fromTo(marqueeScroll, {
                    x: `${scrollStart}vw`
                }, {
                    x: `${scrollEnd}vw`,
                    ease: 'none'
                });
            }, marquee);
            if ($7fe0fc961c0a5700$var$hasScrollTrigger) ScrollTrigger.refresh();
        });
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupMarqueeScrollDirection(container) {
    if (!container) return;
    container.querySelectorAll('[data-marquee-scroll-direction-target]').forEach((marquee)=>{
        marquee._destroyMarquee?.();
    });
}
// ---------------------------
// Image Fly-In (d-d26-imgfly)
// Init in initAfterEnterFunctions, cleanup in barba.hooks.afterLeave
// ---------------------------
function $7fe0fc961c0a5700$var$initImgFly(container = document) {
    const wrappers = container.querySelectorAll('.d-d26-imgfly');
    if (!wrappers.length) return;
    wrappers.forEach((wrapper)=>{
        // Avoid double-init
        if (wrapper._imgflyTL) return;
        const img1 = wrapper.querySelector('.d-d26-imgfly-1 img');
        const img2 = wrapper.querySelector('.d-d26-imgfly-2 img');
        if (!img1 && !img2) return;
        const isLeft = wrapper.getAttribute('data-imgfly-direction') === 'left';
        const fromX = isLeft ? -300 : 300;
        // right: +1 to +5deg | left: -1 to -5deg
        const randomRotation = ()=>{
            const deg = gsap.utils.random(1, 9);
            return isLeft ? -deg : deg;
        };
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'bottom bottom',
                toggleActions: 'play none none none'
            }
        });
        const vars = (rotation)=>({
                xPercent: 0,
                rotation: rotation,
                duration: 1,
                ease: 'energy',
                force3D: true
            });
        if (img1) tl.fromTo(img1, {
            xPercent: fromX,
            rotation: 0
        }, vars(randomRotation()), 0);
        if (img2) tl.fromTo(img2, {
            xPercent: fromX,
            rotation: 0
        }, vars(randomRotation()), 0.1);
        wrapper._imgflyTL = tl;
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupImgFly(container) {
    if (!container) return;
    container.querySelectorAll('.d-d26-imgfly').forEach((wrapper)=>{
        if (wrapper._imgflyTL) {
            wrapper._imgflyTL.scrollTrigger?.kill();
            wrapper._imgflyTL.kill();
            wrapper._imgflyTL = null;
        }
        // Reset inline styles so a re-entered page starts clean
        gsap.set(wrapper.querySelectorAll('.d-d26-imgfly-1 img, .d-d26-imgfly-2 img'), {
            clearProps: 'transform'
        });
    });
}
// ---------------------------
// Pixelate Image Render
// Init in initAfterEnterFunctions, cleanup in barba.hooks.afterLeave
// ---------------------------
function $7fe0fc961c0a5700$var$initPixelateImageRender(container = document) {
    const roots = container.querySelectorAll('[data-pixelate-render]');
    if (!roots.length) return;
    // Reduced motion: leave the image as-is, no canvas, no animation
    if ($7fe0fc961c0a5700$var$reducedMotion) return;
    // Defaults (overridable per element via data attributes)
    const renderDuration = 150; // ms per step
    const renderSteps = 12; // steps from chunky to sharp
    const renderColumns = 12; // columns at the most pixelated stage
    roots.forEach((root)=>{
        // Avoid double-init if this ever runs twice on the same root
        if (root._destroyPixelate) return;
        const img = root.querySelector('[data-pixelate-render-img]');
        if (!img) return;
        const trigger = (root.getAttribute('data-pixelate-render-trigger') || 'load').toLowerCase();
        // Per-element overrides
        const durAttr = parseInt(root.getAttribute('data-pixelate-render-duration'), 10);
        const stepsAttr = parseInt(root.getAttribute('data-pixelate-render-steps'), 10);
        const colsAttr = parseInt(root.getAttribute('data-pixelate-render-columns'), 10);
        const fitMode = (root.getAttribute('data-pixelate-render-fit') || 'cover').toLowerCase();
        const elRenderDuration = Number.isFinite(durAttr) ? Math.max(16, durAttr) : renderDuration;
        const elRenderSteps = Number.isFinite(stepsAttr) ? Math.max(1, stepsAttr) : renderSteps;
        const elRenderColumns = Number.isFinite(colsAttr) ? Math.max(1, colsAttr) : renderColumns;
        // Canvas overlay
        const canvas = document.createElement('canvas');
        canvas.setAttribute('data-pixelate-canvas', '');
        canvas.style.position = 'absolute';
        canvas.style.inset = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'none';
        const hadPosition = !!root.style.position;
        if (!hadPosition) root.style.position = 'relative';
        root.appendChild(canvas);
        const ctx = canvas.getContext('2d', {
            alpha: true
        });
        ctx.imageSmoothingEnabled = false;
        const back = document.createElement('canvas');
        const tiny = document.createElement('canvas');
        const bctx = back.getContext('2d', {
            alpha: true
        });
        const tctx = tiny.getContext('2d', {
            alpha: true
        });
        let naturalW = 0, naturalH = 0;
        let playing = false, stageIndex = 0, stageStart = 0;
        let backDirty = true;
        let steps = [
            elRenderColumns
        ];
        let destroyed = false;
        // Tracked so cleanup can tear everything down
        let rafId = 0;
        let resizeTimeout = 0;
        let removeTimeout = 0;
        let io = null;
        let resizeBound = false;
        const pendingLoadListeners = [];
        const interactionListeners = []; // { type, fn }
        function fitCanvas() {
            const r = root.getBoundingClientRect();
            const dpr = Math.max(1, Math.floor(window.devicePixelRatio || 1));
            const w = Math.max(1, Math.round(r.width * dpr));
            const h = Math.max(1, Math.round(r.height * dpr));
            if (canvas.width !== w || canvas.height !== h) {
                canvas.width = w;
                canvas.height = h;
                back.width = w;
                back.height = h;
                backDirty = true;
            }
            regenerateSteps();
        }
        function regenerateSteps() {
            const cw = Math.max(1, canvas.width);
            const startCols = Math.min(elRenderColumns, cw);
            const total = Math.max(1, elRenderSteps);
            const use = Math.max(1, Math.floor(total * 0.9)); // use 90% of the steps
            const a = [];
            const ratio = Math.pow(cw / startCols, 1 / total);
            for(let i = 0; i < use; i++)a.push(Math.max(1, Math.round(startCols * Math.pow(ratio, i))));
            for(let i = 1; i < a.length; i++)if (a[i] <= a[i - 1]) a[i] = a[i - 1] + 1;
            steps = a.length ? a : [
                startCols
            ];
        }
        function drawImageToBack() {
            if (!backDirty || !naturalW || !naturalH) return;
            const cw = back.width, ch = back.height;
            let dw = cw, dh = ch, dx = 0, dy = 0;
            if (fitMode !== 'stretch') {
                const s = fitMode === 'cover' ? Math.max(cw / naturalW, ch / naturalH) : Math.min(cw / naturalW, ch / naturalH);
                dw = Math.max(1, Math.round(naturalW * s));
                dh = Math.max(1, Math.round(naturalH * s));
                dx = cw - dw >> 1;
                dy = ch - dh >> 1;
            }
            bctx.clearRect(0, 0, cw, ch);
            bctx.imageSmoothingEnabled = true;
            bctx.drawImage(img, dx, dy, dw, dh);
            backDirty = false;
        }
        function pixelate(columns) {
            const cw = canvas.width, ch = canvas.height;
            const cols = Math.max(1, Math.floor(columns));
            const rows = Math.max(1, Math.round(cols * (ch / cw)));
            if (tiny.width !== cols || tiny.height !== rows) {
                tiny.width = cols;
                tiny.height = rows;
            }
            tctx.imageSmoothingEnabled = false;
            tctx.clearRect(0, 0, cols, rows);
            tctx.drawImage(back, 0, 0, cw, ch, 0, 0, cols, rows);
            ctx.imageSmoothingEnabled = false;
            ctx.clearRect(0, 0, cw, ch);
            ctx.drawImage(tiny, 0, 0, cols, rows, 0, 0, cw, ch);
        }
        function draw(stepCols) {
            if (!canvas.width || !canvas.height) return;
            drawImageToBack();
            pixelate(stepCols);
        }
        // Run `fn` once the image has loaded (immediately if it already has)
        function whenImageReady(fn) {
            if (img.complete && img.naturalWidth) fn();
            else {
                img.addEventListener('load', fn, {
                    once: true
                });
                pendingLoadListeners.push(fn);
            }
        }
        function unbindResize() {
            if (!resizeBound) return;
            window.removeEventListener('resize', onWindowResize);
            resizeBound = false;
        }
        function bindResize() {
            if (resizeBound) return;
            window.addEventListener('resize', onWindowResize);
            resizeBound = true;
        }
        function animate(t) {
            if (!playing || destroyed) return;
            if (!stageStart) stageStart = t;
            if (t - stageStart >= elRenderDuration) {
                stageIndex++;
                stageStart = t;
            }
            draw(steps[Math.min(stageIndex, steps.length - 1)]);
            if (stageIndex >= steps.length - 1) {
                canvas.style.opacity = '0';
                playing = false;
                unbindResize();
                removeTimeout = setTimeout(()=>{
                    canvas.remove();
                }, 250);
                return;
            }
            rafId = requestAnimationFrame(animate);
        }
        function prime() {
            fitCanvas();
            whenImageReady(()=>{
                if (destroyed) return;
                naturalW = img.naturalWidth;
                naturalH = img.naturalHeight;
                if (!naturalW || !naturalH) return;
                stageIndex = 0;
                canvas.style.opacity = '1';
                backDirty = true;
                draw(steps[0]);
            });
        }
        function start() {
            if (playing || destroyed) return;
            fitCanvas();
            whenImageReady(()=>{
                if (destroyed) return;
                naturalW = img.naturalWidth;
                naturalH = img.naturalHeight;
                if (!naturalW || !naturalH) return;
                stageIndex = 0;
                stageStart = 0;
                canvas.style.opacity = '1';
                backDirty = true;
                playing = true;
                rafId = requestAnimationFrame(animate);
            });
        }
        function onResize() {
            if (destroyed) return;
            fitCanvas();
            if (!playing) draw(steps[Math.min(stageIndex, steps.length - 1)] || steps[0]);
        }
        function onWindowResize() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(onResize, 250);
        }
        // ---------- Triggers ----------
        if (trigger === 'load') {
            prime();
            start();
        } else if (trigger === 'inview') {
            prime();
            io = new IntersectionObserver((es)=>{
                for (const e of es)if (e.isIntersecting) {
                    start();
                    io.disconnect();
                    io = null;
                    break;
                }
            }, {
                rootMargin: '0px 0px -25% 0px',
                threshold: 0.25
            });
            io.observe(root);
            bindResize();
        } else if (trigger === 'hover') {
            prime();
            root.addEventListener('mouseenter', start, {
                once: true
            });
            interactionListeners.push({
                type: 'mouseenter',
                fn: start
            });
            bindResize();
        } else if (trigger === 'click') {
            prime();
            root.addEventListener('click', start, {
                once: true
            });
            interactionListeners.push({
                type: 'click',
                fn: start
            });
            bindResize();
        }
        // ---------- Cleanup (called from Barba afterLeave) ----------
        root._destroyPixelate = ()=>{
            destroyed = true;
            playing = false;
            cancelAnimationFrame(rafId);
            clearTimeout(resizeTimeout);
            clearTimeout(removeTimeout);
            io?.disconnect();
            io = null;
            unbindResize();
            pendingLoadListeners.forEach((fn)=>img.removeEventListener('load', fn));
            pendingLoadListeners.length = 0;
            interactionListeners.forEach(({ type: type, fn: fn })=>root.removeEventListener(type, fn));
            interactionListeners.length = 0;
            canvas.remove();
            if (!hadPosition) root.style.position = '';
            root._destroyPixelate = null;
        };
    });
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupPixelateImageRender(container) {
    if (!container) return;
    container.querySelectorAll('[data-pixelate-render]').forEach((root)=>{
        root._destroyPixelate?.();
    });
}
// ---------------------------
// Project Screens CRT Bulge (velocity-driven)
// ---------------------------
function $7fe0fc961c0a5700$var$initProjectImgWarp(container = document) {
    if ($7fe0fc961c0a5700$var$reducedMotion || !$7fe0fc961c0a5700$var$hasLenis || !$7fe0fc961c0a5700$var$lenis) return;
    const wraps = Array.from(container.querySelectorAll('.d-project-screens .d-ct-image'));
    if (!wraps.length) return;
    if (container._projectWarpMM) return;
    // Tuning
    const VEL_REF = 40; // lenis velocity = full effect (lower = more sensitive)
    const RISE = 0.25; // how fast the effect fades in
    const FALL = 0.08; // how fast it fades out
    const BULGE = 150; // STATIC displacement strength (px), baked into the filter
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const useFilter = !isSafari;
    const mm = gsap.matchMedia();
    mm.add('(min-width: 769px)', ()=>{
        const FILTER_ID = 'd-crt-bulge';
        let filterSvg = null;
        // Static barrel displacement filter (built once, never changed afterwards)
        if (useFilter) {
            const S = 128;
            const c = document.createElement('canvas');
            c.width = c.height = S;
            const cx = c.getContext('2d');
            const data = cx.createImageData(S, S);
            for(let y = 0; y < S; y++)for(let x = 0; x < S; x++){
                const nx = x / (S - 1) * 2 - 1;
                const ny = y / (S - 1) * 2 - 1;
                const r2 = (nx * nx + ny * ny) / 2;
                const i = (y * S + x) * 4;
                data.data[i] = 128 + 127 * nx * r2;
                data.data[i + 1] = 128 + 127 * ny * r2;
                data.data[i + 2] = 128;
                data.data[i + 3] = 255;
            }
            cx.putImageData(data, 0, 0);
            filterSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            filterSvg.setAttribute('width', '0');
            filterSvg.setAttribute('height', '0');
            filterSvg.setAttribute('aria-hidden', 'true');
            filterSvg.style.cssText = 'position:absolute;width:0;height:0;pointer-events:none';
            filterSvg.innerHTML = `
        <filter id="${FILTER_ID}" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB">
          <feImage href="${c.toDataURL()}" preserveAspectRatio="none" result="map"/>
          <feDisplacementMap in="SourceGraphic" in2="map" scale="${BULGE}" xChannelSelector="R" yChannelSelector="G"/>
        </filter>`;
            document.body.appendChild(filterSvg);
        }
        // One bulged layer per image, created only while the image is near the viewport
        const layers = new Map(); // wrap -> layer element
        const addLayer = (wrap)=>{
            if (layers.has(wrap)) return;
            const src = wrap.querySelector('img');
            if (!src) return;
            const layer = document.createElement('div');
            layer.className = 'd-crt-layer';
            layer.setAttribute('aria-hidden', 'true');
            layer.style.opacity = '0.001'; // not 0, so the browser keeps it rasterized and ready
            const img = document.createElement('img');
            img.alt = '';
            img.decoding = 'async';
            img.loading = 'eager';
            img.src = src.currentSrc || src.src;
            if (useFilter) img.style.filter = `url(#${FILTER_ID})`;
            layer.appendChild(img);
            wrap.appendChild(layer);
            layers.set(wrap, layer);
        };
        const removeLayer = (wrap)=>{
            const layer = layers.get(wrap);
            if (!layer) return;
            layer.remove();
            layers.delete(wrap);
        };
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((e)=>e.isIntersecting ? addLayer(e.target) : removeLayer(e.target));
        }, {
            rootMargin: '60% 0px'
        }); // build layers a bit ahead of time
        wraps.forEach((w)=>io.observe(w));
        let v = 0;
        let lastA = -1;
        const tick = ()=>{
            const target = Math.min(1, Math.abs($7fe0fc961c0a5700$var$lenis.velocity) / VEL_REF);
            v += (target - v) * (target > v ? RISE : FALL);
            const a = v < 0.01 ? 0 : v;
            // Skip tiny changes, so we don't touch the DOM every frame
            if (a === lastA || a !== 0 && Math.abs(a - lastA) < 0.004) return;
            lastA = a;
            const o = Math.max(a, 0.001).toFixed(3);
            layers.forEach((layer)=>{
                layer.style.opacity = o;
            });
        };
        gsap.ticker.add(tick);
        return ()=>{
            gsap.ticker.remove(tick);
            io.disconnect();
            layers.forEach((layer)=>layer.remove());
            layers.clear();
            filterSvg?.remove();
        };
    });
    container._projectWarpMM = mm;
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupProjectImgWarp(container) {
    if (!container) return;
    if (container._projectWarpMM) {
        container._projectWarpMM.revert();
        container._projectWarpMM = null;
    }
}
// ---------------------------
// Effect 036 Fluted Glass on the .hover image (mouse-reactive, canvas 2D)
// Init in initAfterEnterFunctions (after initEffect036), cleanup in barba.hooks.afterLeave
// ---------------------------
function $7fe0fc961c0a5700$var$initEffect036Glass(container = document) {
    if ($7fe0fc961c0a5700$var$reducedMotion) return;
    const roots = Array.from(container.querySelectorAll('.mwg_effect036'));
    const targets = roots.map((root)=>root.querySelector('.sentence .hover img')).filter(Boolean);
    if (!targets.length) return;
    if (container._effect036GlassMM) return;
    // Tuning
    const FLUTE_W = 20; // flute width in CSS px (smaller = finer ribs)
    const SUB = 1; // slices per flute
    const BASE = 0.45; // glass strength far from the cursor
    const K = 1.4; // compression at the cursor
    const SHIFT = 1.2; // how strongly flutes lean toward the cursor
    const RADIUS = 0.28; // influence radius, fraction of image width
    const FLIP = -1; // -1 = mirrored slices (real reeded glass), 1 = not mirrored
    const FOLLOW = 0.2; // cursor smoothing
    const MARGIN = 0; // glass wakes up when the cursor is this fraction outside the image
    const mm = gsap.matchMedia();
    mm.add('(min-width: 769px) and (hover: hover) and (pointer: fine)', ()=>{
        const states = targets.map((img)=>({
                img: img,
                canvas: null,
                ctx: null,
                cw: 0,
                ch: 0,
                I: 0,
                tI: 0,
                mx: 0,
                init: false
            }));
        const pointer = {
            x: -9999,
            y: -9999
        };
        const onMove = (e)=>{
            pointer.x = e.clientX;
            pointer.y = e.clientY;
        };
        const onLeave = ()=>{
            pointer.x = pointer.y = -9999;
        };
        window.addEventListener('pointermove', onMove, {
            passive: true
        });
        document.documentElement.addEventListener('mouseleave', onLeave);
        const ensureCanvas = (st)=>{
            if (st.canvas) return;
            const c = document.createElement('canvas');
            c.setAttribute('aria-hidden', 'true');
            c.dataset.effect036Glass = '';
            c.style.cssText = 'position:absolute;pointer-events:none;display:block;opacity:0;';
            st.img.after(c);
            st.canvas = c;
            st.ctx = c.getContext('2d', {
                alpha: true
            });
            st.cw = 0;
            st.ch = 0;
        };
        const destroyCanvas = (st)=>{
            st.canvas?.remove();
            st.canvas = null;
            st.ctx = null;
            st.init = false;
        };
        // Keep the canvas glued exactly over the image
        const syncCanvas = (st, W, H)=>{
            const { img: img, canvas: c } = st;
            const cs = getComputedStyle(img);
            const dpr = Math.min(window.devicePixelRatio || 1, 2);
            const cw = Math.round(W * dpr), ch = Math.round(H * dpr);
            if (cw !== st.cw || ch !== st.ch) {
                c.width = cw;
                c.height = ch;
                st.cw = cw;
                st.ch = ch;
                st.ctx.imageSmoothingEnabled = true;
            }
            st.dpr = dpr;
            c.style.left = img.offsetLeft + 'px';
            c.style.top = img.offsetTop + 'px';
            c.style.width = W + 'px';
            c.style.height = H + 'px';
            c.style.transform = cs.transform === 'none' ? '' : cs.transform;
            c.style.transformOrigin = cs.transformOrigin;
            c.style.borderRadius = cs.borderRadius;
            c.style.zIndex = cs.zIndex === 'auto' ? '' : cs.zIndex;
            return parseFloat(cs.opacity) * (cs.visibility === 'hidden' ? 0 : 1);
        };
        const draw = (st)=>{
            const { img: img, ctx: ctx, cw: cw, ch: ch, dpr: dpr } = st;
            const nw = img.naturalWidth, nh = img.naturalHeight;
            // object-fit: cover crop of the source
            const ba = cw / ch, ia = nw / nh;
            let sx0 = 0, sy0 = 0, sw0 = nw, sh0 = nh;
            if (ia > ba) {
                sw0 = nh * ba;
                sx0 = (nw - sw0) / 2;
            } else {
                sh0 = nw / ba;
                sy0 = (nh - sh0) / 2;
            }
            const kx = sw0 / cw;
            const fw = FLUTE_W * dpr;
            const n = Math.max(1, Math.round(cw / fw));
            const fwa = cw / n;
            const mxp = st.mx * dpr;
            const I = st.I;
            ctx.clearRect(0, 0, cw, ch);
            for(let i = 0; i < n; i++){
                const x0 = i * fwa;
                const w = fwa;
                const cx = x0 + w / 2;
                const d = (cx - mxp) / (cw * RADIUS);
                const infl = Math.exp(-d * d);
                const s = BASE + (1 - BASE) * infl;
                const k = 1 + s * I * K;
                const shift = -d * infl * w * SHIFT * I;
                for(let j = 0; j < SUB; j++){
                    const u0 = j / SUB, u1 = (j + 1) / SUB;
                    const dx0 = Math.round(x0 + w * u0);
                    const dx1 = Math.round(x0 + w * u1);
                    if (dx1 <= dx0) continue;
                    const u = u0 + u1 - 1;
                    const srcCenter = cx + FLIP * u * k * w / 2 + shift;
                    const srcW = k * w / SUB * kx;
                    const sw = Math.min(srcW, sw0);
                    let sx = sx0 + srcCenter * kx - srcW / 2;
                    sx = Math.max(sx0, Math.min(sx0 + sw0 - sw, sx));
                    ctx.drawImage(img, sx, sy0, sw, sh0, dx0, 0, dx1 - dx0, ch);
                }
            }
        };
        const tick = ()=>{
            states.forEach((st)=>{
                const { img: img } = st;
                if (!img.isConnected || !img.complete || !img.naturalWidth) return;
                const W = img.offsetWidth, H = img.offsetHeight;
                if (!W || !H) {
                    if (st.canvas) destroyCanvas(st);
                    return;
                }
                // Cursor position relative to the image's on-screen box
                const r = img.getBoundingClientRect();
                const px = pointer.x - r.left;
                const py = pointer.y - r.top;
                const over = px > -r.width * MARGIN && px < r.width * (1 + MARGIN) && py > -r.height * MARGIN && py < r.height * (1 + MARGIN);
                st.tI = over ? 1 : 0;
                if (st.tI === 0 && st.I < 0.01) {
                    st.I = 0;
                    if (st.canvas) destroyCanvas(st);
                    return;
                }
                ensureCanvas(st);
                // Convert to canvas-local CSS px (handles scale if the image is transformed)
                const lx = px * (W / r.width);
                if (!st.init) {
                    st.mx = lx;
                    st.init = true;
                }
                st.I += (st.tI - st.I) * (st.tI > st.I ? 0.16 : 0.1);
                st.mx += (lx - st.mx) * FOLLOW;
                const imgOpacity = syncCanvas(st, W, H);
                st.canvas.style.opacity = (Math.min(1, st.I * 1.6) * imgOpacity).toFixed(3);
                draw(st);
            });
        };
        gsap.ticker.add(tick);
        return ()=>{
            gsap.ticker.remove(tick);
            window.removeEventListener('pointermove', onMove);
            document.documentElement.removeEventListener('mouseleave', onLeave);
            states.forEach(destroyCanvas);
        };
    });
    container._effect036GlassMM = mm;
}
// DO NOT REMOVE THIS
function $7fe0fc961c0a5700$var$cleanupEffect036Glass(container) {
    if (!container) return;
    if (container._effect036GlassMM) {
        container._effect036GlassMM.revert();
        container._effect036GlassMM = null;
    }
}

})();
//# sourceMappingURL=dooi.js.map
